/*! ************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2017 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 *
 * *************************************************************************/

/*! Copyright for external libraries used in ADBMobile library */
/*!
 * JavaScript MD5 1.0.1
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 * 
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

function ADBinit(ADBMobileConfig) {
  var ADBMobile_platform = (function() {
      function a(a, b) {
        if (!a) return null;
        try {
          return (
            b
              ? window.localStorage.setItem(a, b)
              : window.localStorage.removeItem(a),
            b
          );
        } catch (c) {
          _logger.error("Failed to store data element: " + c);
        }
        return null;
      }
      function b(a) {
        if (!a) return null;
        try {
          return window.localStorage.getItem(a);
        } catch (b) {
          _logger.error("Failed to retrieve data element: " + b);
        }
        return null;
      }
      function c(a, b, c, d, e, f) {
        if (!a)
          return (
            _logger.error("HTTPRequestAsync - URL required but was not passed"),
            null
          );
        (c = c || {}), (e = e || 500), (f = f || function() {});
        var g = new XMLHttpRequest();
        (g.onreadystatechange = function() {
          4 == g.readyState &&
            (f(g.status, g.responseText, d || a), (f = function() {}));
        }),
          (g.timeout = e),
          (g.ontimeout = function() {
            f(0, null, a), (f = function() {});
          }),
          g.open(b, a, !0),
          Object.keys(c).forEach(function(a) {
            g.setRequestHeader(a, this[a]);
          }, c),
          g.send(d);
      }
      function d() {
        return "Chromecast resolution";
      }
      function e() {
        return "undefined" != typeof cast && cast.receiver
          ? cast.receiver.VERSION
          : "Chromecast OS";
      }
      function f() {
        return "Chromecast";
      }
      function g() {
        return "Chromecast App ID";
      }
      function h() {
        return g();
      }
      function i() {
        return Math.floor(new Date().getTime() / 1e3);
      }
      function j() {
        return new Date().getTime();
      }
      function k() {
        return new Date().toISOString();
      }
      function l() {
        return "00/00/0000 00:00:00 0 " + new Date().getTimezoneOffset();
      }
      function m(a, b) {
        return setInterval(a, b);
      }
      function n(a) {
        clearInterval(a);
      }
      function o(a) {
        return window.btoa(a);
      }
      function p(a) {
        return window.atob(a);
      }
      function q(a) {
        var b;
        if (window.DOMParser) {
          b = new DOMParser().parseFromString(a, "text/xml");
        }
        return b;
      }
      function r(a) {
        return a.item(0);
      }
      return {
        httpRequestAsync: c,
        writeValue: a,
        readValue: b,
        getResolution: d,
        getDeviceName: f,
        getOSVersion: e,
        getAppID: g,
        getDefaultPageName: h,
        getTimeSince1970: i,
        getTimeSince1970Millis: j,
        getDateInISOString: k,
        getTimestampString: l,
        setInterval: m,
        clearInterval: n,
        encodeBase64String: o,
        decodeBase64String: p,
        parseXML: q,
        getBaseItem: r
      };
    })(),
    ADBMobile = (function() {
      var a = (function() {
          function a() {
            (f = ADBMobile_platform.readValue("adb_aid")),
              (g = ADBMobile_platform.readValue("adb_ignore_aid"));
          }
          function b() {
            return "yxxxxxxxxxxxxxxx-zxxxxxxxxxxxxxxx".replace(
              /[xyz]/g,
              function(a) {
                return "0123456789ABCDEF".charAt(
                  Math.floor(Math.random() * ({ y: 7, x: 16, z: 4 }[a] || 0))
                );
              }
            );
          }
          function c() {
            (f = null),
              (g = null),
              ADBMobile_platform.writeValue("adb_aid", ""),
              ADBMobile_platform.writeValue("adb_ignore_aid", "");
          }
          function d(a) {
            if (h.isFunction(a))
              return f
                ? void a(f)
                : g && e.visitorIDServiceEnabled()
                  ? void a(null)
                  : e.getPrivacyStatus() !== e.PRIVACY_STATUS_OPT_IN
                    ? void a(null)
                    : void k.getMarketingCloudIDAsync(function(c) {
                        var d =
                          (e.ssl() ? "https" : "http") +
                          "://" +
                          e.trackingServer() +
                          "/id";
                        c && (d += k.getAnalyticsIDRequestParameterString()),
                          ADBMobile_platform.httpRequestAsync(
                            d,
                            "GET",
                            {},
                            null,
                            500,
                            function(c, d) {
                              if (
                                e.getPrivacyStatus() !== e.PRIVACY_STATUS_OPT_IN
                              )
                                return void a(null);
                              200 == c &&
                                d &&
                                ((f = JSON.parse(d).id),
                                ADBMobile_platform.writeValue("adb_aid", f)),
                                !f && e.visitorIDServiceEnabled()
                                  ? ADBMobile_platform.writeValue(
                                      "adb_ignore_aid",
                                      !0
                                    )
                                  : ADBMobile_platform.readValue("adb_aid") ||
                                    ((f = b()),
                                    ADBMobile_platform.writeValue(
                                      "adb_aid",
                                      f
                                    )),
                                f &&
                                  e.visitorIDServiceEnabled() &&
                                  k.idSync({ AVID: f }),
                                a(f);
                            }
                          );
                      });
          }
          var f, g;
          return { init: a, getAIDAsync: d, purgeAid: c };
        })(),
        b = (function() {
          function a(a, c) {
            var d = {};
            b(c) &&
              Object.keys(c).forEach(function(a) {
                d[a] = this[a];
              }, c),
              g(
                d,
                { pageName: a || ADBMobile_platform.getDefaultPageName() },
                ADBMobile_platform.getTimeSince1970()
              );
          }
          function b(a) {
            return (
              null !== a && (void 0 !== a && a.constructor === {}.constructor)
            );
          }
          function d(a, c, d) {
            var e = {};
            b(c) &&
              Object.keys(c).forEach(function(a) {
                e[a] = this[a];
              }, c),
              (e["a.internalaction"] = a);
            var f = {
              pe: "lnk_o",
              pev2: "ADBINTERNAL:" + a,
              pageName: ADBMobile_platform.getDefaultPageName()
            };
            g(e, f, d);
          }
          function f(a, c) {
            var d = {};
            b(c) &&
              Object.keys(c).forEach(function(a) {
                d[a] = this[a];
              }, c),
              (d["a.action"] = a);
            var e = {
              pe: "lnk_o",
              pev2: "AMACTION:" + a,
              pageName: ADBMobile_platform.getDefaultPageName()
            };
            g(d, e, ADBMobile_platform.getTimeSince1970());
          }
          function g(a, b, d) {
            if (e.analyticsEnabled()) {
              (a = a || {}),
                (b = b || {}),
                (d = d || ADBMobile_platform.getTimeSince1970()),
                (a["a.Resolution"] = ADBMobile_platform.getResolution()),
                (a["a.DeviceName"] = ADBMobile_platform.getDeviceName()),
                (a["a.OSVersion"] = ADBMobile_platform.getOSVersion()),
                (a["a.AppID"] = ADBMobile_platform.getAppID());
              var f = e.getUserIdentifier();
              f && (b.vid = f),
                e.offlineTrackingEnabled() && (b.ts = d),
                (b.ce = e.characterSet()),
                (b.t = ADBMobile_platform.getTimestampString()),
                Object.keys(a).forEach(function(a) {
                  "&&" === a.slice(0, 2) &&
                    ((b[a.slice(2)] = this[a]), delete this[a]);
                }, a);
              var g =
                "ndh=1" + h.serializeParameters(b) + h.serializeContextData(a);
              c.queue(g, ADBMobile_platform.getTimeSince1970()),
                u.checkFor3rdPartyCallbacks(b, a);
            }
          }
          return { trackAction: f, trackState: a, trackInternal: d };
        })(),
        c = (function() {
          function b(a, b) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN
              ? (g.debug("Analytics - Queued Hit(" + a + ")"),
                i.push({ frag: a, ts: b }),
                c())
              : g.debug(
                  "Analytics - Not queueing hit. Privacy is not set to optedin."
                );
          }
          function c() {
            if (!l) {
              l = !0;
              var b = i.shift();
              if (!b) return void (l = !1);
              if (!e.offlineTrackingEnabled()) {
                var f = ADBMobile_platform.getTimeSince1970() - b.ts;
                if (f > 60)
                  return (
                    g.debug(
                      "Analytics - Hit is greater than 60 seconds old (" +
                        f +
                        "s), will be deleted (" +
                        b.frag +
                        ")"
                    ),
                    (l = !1),
                    void c()
                  );
              }
              k.idSync(null, function(e) {
                var f = b.frag;
                e && (f += h.serializeParameters(k.getAnalyticsParameters())),
                  a.getAIDAsync(function(a) {
                    a && (f += h.serializeKeyValuePair("aid", a)),
                      ADBMobile_platform.httpRequestAsync(
                        d(),
                        "POST",
                        { "Content-type": "application/x-www-form-urlencoded" },
                        f,
                        2e3,
                        function(a, b, d) {
                          200 == a
                            ? g.debug(
                                "Analytics - Successfully sent hit (" + d + ")"
                              )
                            : g.error(
                                "Analytics - Unable to send hit (" +
                                  d +
                                  ") response (" +
                                  b +
                                  ")"
                              ),
                            (l = !1),
                            c();
                        }
                      );
                  });
              });
            }
          }
          function d() {
            var a = e.ssl() ? "https" : "http";
            return (a +=
              "://" +
              e.trackingServer() +
              "/b/ss/" +
              e.reportSuiteIDs() +
              "/0/" +
              j.codeVersion +
              "/s" +
              Math.floor(1e7 * Math.random()));
          }
          function f() {
            i = [];
          }
          var i = [],
            l = !1;
          return { queue: b, purgeAnalyticsQueue: f };
        })(),
        d = (function() {
          function a() {
            if (!u) {
              u = !0;
              var b = t.shift();
              if (!b) return void (u = !1);
              ADBMobile_platform.httpRequestAsync(
                b,
                "GET",
                {},
                "",
                2e3,
                function(b, c, d) {
                  if (
                    200 == b &&
                    e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN
                  ) {
                    g.debug(
                      "Audience Manager - Successfully Sent Signal (" +
                        d +
                        "), response (" +
                        c +
                        ")"
                    );
                    var f = null;
                    try {
                      f = JSON.parse(c);
                    } catch (k) {
                      g.debug(
                        "Audience Manager - Unable to parse response (" +
                          k +
                          ")"
                      );
                    }
                    if (f) {
                      var h = f.uuid || null;
                      h && q(h);
                      (f.dests || []).map(function(a) {
                        var b = a.c || null;
                        b &&
                          (g.debug(
                            "Audience Manager - Forwarding 'dests' request (" +
                              b +
                              ")"
                          ),
                          ADBMobile_platform.httpRequestAsync(
                            b,
                            "GET",
                            {},
                            "",
                            2e3,
                            null
                          ));
                      });
                      var i = f.stuff || [],
                        j = {};
                      i.map(function(a) {
                        var b = a.cn || null,
                          c = a.cv || null;
                        b && c && (j[b] = c);
                      }),
                        l(j);
                    }
                  } else
                    g.error(
                      "Audience Manager - Unable to send signal (" + d + ")"
                    );
                  (u = !1), a();
                }
              );
            }
          }
          function b(b) {
            if (e.audienceManagerEnabled())
              if (e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN) {
                var d = c(b);
                g.debug("Audience Manager - Queued Signal(" + d + ")"),
                  t.push(d),
                  a();
              } else
                g.debug(
                  "Audience Manager - Not queueing hit. Privacy is not set to optedin."
                );
          }
          function c(a) {
            return (
              d() +
              f(a) +
              i() +
              "&d_ptfm=appletv&d_dst=1&d_rtbd=json"
            ).replace(/\?\&/i, "?");
          }
          function d() {
            return e.ssl() ? "https" : "http://" + e.aamServer() + "/event?";
          }
          function f(a) {
            a = a || {};
            var b = "";
            return (
              Object.keys(a).forEach(function(a) {
                b += h.serializeKeyValuePair(j(a), this[a]);
              }, a),
              b
            );
          }
          function i() {
            var a = "",
              b = r() || null;
            b && (a += h.serializeKeyValuePair("d_uuid", b));
            var c = o() || null,
              d = p() || null;
            return (
              c &&
                d &&
                (a +=
                  h.serializeKeyValuePair("d_dpid", c) +
                  h.serializeKeyValuePair("d_dpuuid", d)),
              (a += k.getAAMParameterString())
            );
          }
          function j(a) {
            return a.replace("/./g", "_");
          }
          function l(a) {
            var b = JSON.stringify(a);
            ADBMobile_platform.writeValue("adb_aam_profile", b);
          }
          function m() {
            var a = ADBMobile_platform.readValue("adb_aam_profile");
            return JSON.parse(a);
          }
          function n(a, b) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN &&
              (ADBMobile_platform.writeValue("adb_aam_dpid", a),
              ADBMobile_platform.writeValue("adb_aam_dpuuid", b));
          }
          function o() {
            return ADBMobile_platform.readValue("adb_aam_dpid");
          }
          function p() {
            return ADBMobile_platform.readValue("adb_aam_dpuuid");
          }
          function q(a) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN &&
              ADBMobile_platform.writeValue("adb_aam_uuid", a);
          }
          function r() {
            return ADBMobile_platform.readValue("adb_aam_uuid");
          }
          function s() {
            (t = []),
              ADBMobile_platform.writeValue("adb_aam_profile", ""),
              ADBMobile_platform.writeValue("adb_aam_dpid", ""),
              ADBMobile_platform.writeValue("adb_aam_dpuuid", ""),
              ADBMobile_platform.writeValue("adb_aam_uuid", "");
          }
          var t = [],
            u = !1;
          return {
            getUUID: r,
            getDpid: o,
            getDpuuid: p,
            setDpidAndDpuuid: n,
            getVisitorProfile: m,
            submitSignal: b,
            purgeAamIdsAndQueue: s
          };
        })(),
        e = (function() {
          function b() {
            if (
              ((w = o() || null),
              w && g.debug("Config - Found custom visitor id(" + w + ")"),
              "object" != typeof ADBMobileConfig || null === ADBMobileConfig)
            )
              return void g.error(
                "Config - Unable to find defined ADBMobileConfig object."
              );
            "object" == typeof ADBMobileConfig.analytics &&
              ((A = ADBMobileConfig.analytics.offlineEnabled || !1),
              (x = ADBMobileConfig.analytics.server || null),
              (y = ADBMobileConfig.analytics.rsids || null),
              (z = ADBMobileConfig.analytics.ssl || !1),
              (B = ADBMobileConfig.analytics.lifecycleTimeout || 300),
              (C = ADBMobileConfig.analytics.privacyDefault || "optedin")),
              g.debug((l(), "Enabled")),
              "object" == typeof ADBMobileConfig.audienceManager &&
                (D = ADBMobileConfig.audienceManager.server || null),
              g.debug((j(), "Enabled")),
              "object" == typeof ADBMobileConfig.marketingCloud &&
                (E = ADBMobileConfig.marketingCloud.org || null),
              g.debug((m(), "Enabled")),
              "object" == typeof ADBMobileConfig.mediaHeartbeat &&
                ((F = ADBMobileConfig.mediaHeartbeat.server || null),
                (G = ADBMobileConfig.mediaHeartbeat.publisher || null),
                (H = ADBMobileConfig.mediaHeartbeat.channel || null),
                (I = ADBMobileConfig.mediaHeartbeat.playerName || null),
                (J = ADBMobileConfig.mediaHeartbeat.ssl || !1),
                (K = ADBMobileConfig.mediaHeartbeat.ovp || null),
                (L = ADBMobileConfig.mediaHeartbeat.sdkVersion || null)),
              g.debug((i(), "Enabled")),
              "object" == typeof ADBMobileConfig.messages &&
                (M = ADBMobileConfig.messages),
              "object" == typeof ADBMobileConfig.remotes &&
                (N = ADBMobileConfig.remotes);
          }
          function i() {
            return !(!F || !l());
          }
          function j() {
            return !!D;
          }
          function l() {
            return !(!x || !y);
          }
          function m() {
            return !!E;
          }
          function n(a) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN &&
              (ADBMobile_platform.writeValue("adb_vid", a), (w = a));
          }
          function o() {
            return w;
          }
          function p() {
            (w = null), ADBMobile_platform.writeValue("adb_vid", "");
          }
          function q(a) {
            ADBMobile_platform.writeValue("adb_privacy", a),
              a === e.PRIVACY_STATUS_OPT_OUT && s();
          }
          function r() {
            var a = ADBMobile_platform.readValue("adb_privacy");
            return a || C;
          }
          function s() {
            a.purgeAid(),
              e.purgeUserIdentifier(),
              c.purgeAnalyticsQueue(),
              d.purgeAamIdsAndQueue(),
              k.purgeVisitorIdService();
          }
          function t(a) {
            h.isFunction(a) && f.getAllIdentifiersAsync(a);
          }
          function u() {
            return M;
          }
          function v() {
            return N;
          }
          var w = null,
            x = null,
            y = null,
            z = !1,
            A = !1,
            B = 300,
            C = "optedin",
            D = null,
            E = null,
            F = null,
            G = null,
            H = null,
            I = null,
            J = !1,
            K = null,
            L = null,
            M = null,
            N = null;
          return {
            getAllIdentifiersAsync: t,
            purgeUserIdentifier: p,
            trackingServer: function() {
              return x;
            },
            reportSuiteIDs: function() {
              return y;
            },
            ssl: function() {
              return z;
            },
            offlineTrackingEnabled: function() {
              return A;
            },
            lifecycleTimeout: function() {
              return B;
            },
            characterSet: function() {
              return "UTF-8";
            },
            privacyDefault: function() {
              return C;
            },
            aamServer: function() {
              return D;
            },
            marketingCloudOrganizationIdentifier: function() {
              return E;
            },
            mTrackingServer: function() {
              return F;
            },
            mPublisher: function() {
              return G;
            },
            mChannel: function() {
              return H;
            },
            mPlayerName: function() {
              return I;
            },
            mSSL: function() {
              return J;
            },
            mOVP: function() {
              return K;
            },
            mSDK: function() {
              return L;
            },
            audienceManagerEnabled: j,
            analyticsEnabled: l,
            visitorIDServiceEnabled: m,
            mediaHearbeatEnabled: i,
            setUserIdentifier: n,
            getUserIdentifier: o,
            setPrivacyStatus: q,
            getPrivacyStatus: r,
            getMessages: u,
            getRemotes: v,
            init: b
          };
        })();
      (e.PRIVACY_STATUS_OPT_IN = "optedin"),
        (e.PRIVACY_STATUS_OPT_OUT = "optedout");
      var f = (function() {
          function b(a) {
            var b = { clbFn: a };
            h(b), i(b);
          }
          function c(a) {
            if (a.mcidReady && a.aidReady) {
              var b = {},
                c = f();
              null !== c && (b.companyContexts = c);
              var d = [],
                e = a.mcid;
              null !== e && d.push(e);
              var h = a.aid;
              null !== h && d.push(h);
              var i = j();
              null !== i && d.push(i);
              var k = l();
              null !== k && d.push(k);
              var n = m();
              if ((null !== n && d.push(n), d.length > 0)) {
                var o = { userIDs: d },
                  p = [];
                p.push(o), (b.users = p);
              }
              try {
                (idJSON = JSON.stringify(b)), a.clbFn(idJSON);
              } catch (q) {
                g.debug("identies.callback threw exception  [" + q + "]");
              }
            }
          }
          function f() {
            var a = e.marketingCloudOrganizationIdentifier();
            return n(a) ? [{ namespace: "imsOrgID", value: a }] : null;
          }
          function h(a) {
            k.getMarketingCloudIDAsync(function(b) {
              var d = null;
              n(b) && (d = { namespace: "4", value: b, type: "namespaceId" }),
                (a.mcid = d),
                (a.mcidReady = !0),
                c(a);
            });
          }
          function i(b) {
            a.getAIDAsync(function(a) {
              var d = null;
              n(a) &&
                (d = { namespace: "avid", value: a, type: "integrationCode" }),
                (b.aid = d),
                (b.aidReady = !0),
                c(b);
            });
          }
          function j() {
            var a = e.getUserIdentifier();
            if (n(a)) {
              var b = e.reportSuiteIDs();
              return {
                namespace: "vid",
                value: a,
                type: "analytics",
                rsids: "string" == typeof b ? b.trim().split(/\s*,\s*/) : []
              };
            }
            return null;
          }
          function l() {
            var a = d.getUUID();
            return n(a)
              ? { namespace: "0", value: a, type: "namespaceId" }
              : null;
          }
          function m() {
            var a = d.getDpid(),
              b = d.getDpuuid();
            return n(a) && n(b)
              ? { namespace: a, value: b, type: "namespaceId" }
              : null;
          }
          function n(a) {
            return "string" == typeof a && 0 !== a.length;
          }
          return { getAllIdentifiersAsync: b };
        })(),
        g = (function() {
          function a(a) {
            "object" == typeof console &&
              console &&
              console.log &&
              console.log(a);
          }
          function b(a) {
            h.isFunction(a) && (j = a);
          }
          function c(a) {
            i = a;
          }
          function d() {
            return i;
          }
          function e(b) {
            i && (a("ADBMobile Warning: " + b), j && j(b));
          }
          function f(b) {
            i && (a("ADBMobile Debug: " + b), j && j(b));
          }
          function g(b) {
            a("ADBMobile Error: " + b), j && j(b);
          }
          var i = !1,
            j = null;
          return {
            setDebugLogging: c,
            getDebugLogging: d,
            setLoggerCallback: b,
            warning: e,
            debug: f,
            error: g
          };
        })(),
        h = (function() {
          function a(a) {
            return "&c." + d(e(a)) + "&.c";
          }
          function b(a, b) {
            return void 0 !== b && null !== b
              ? "&" + encodeURIComponent(a) + "=" + encodeURIComponent(b)
              : "";
          }
          function c(a) {
            var c = "";
            for (var d in a) c += b(d, a[d]);
            return c;
          }
          function d(a) {
            var c = "";
            return (
              (a = a || {}),
              Object.keys(a).forEach(function(a) {
                this[a].v && (c += b(a, this[a].v)),
                  this[a].subValues &&
                    (c += "&" + a + "." + d(this[a].subValues) + "&." + a);
              }, a),
              c
            );
          }
          function e(a) {
            var b = {},
              c = f(a);
            return (
              Object.keys(c).forEach(function(a) {
                var c = this[a];
                !(function a(b, c, d, e) {
                  if (!(e >= d.length)) {
                    var f = d[e];
                    if ((c[f] || (c[f] = {}), d.length - 1 == e))
                      return void (c[f].v = b);
                    c[f].subValues || (c[f].subValues = {}),
                      a(b, c[f].subValues, d, e + 1);
                  }
                })(c, b, a.split("."), 0);
              }, c),
              b
            );
          }
          function f(a) {
            var b = {};
            return (
              (a = a || {}),
              Object.keys(a).forEach(function(a) {
                if ("string" == typeof a) {
                  var c = a.replace(j, ".").replace(k, "");
                  c && (b[c] = this[a]);
                }
              }, a),
              b
            );
          }
          function g(a) {
            var b = {};
            for (var c in a) a.hasOwnProperty(c) && (b[c] = a[c]);
            return b;
          }
          function h(a, b) {
            for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
          }
          function i(a) {
            return "function" == typeof a;
          }
          var j = new RegExp("([.]){2,}", "g"),
            k = new RegExp("[^0-9a-zA-Z._]|^[.]{1,}|[.]{1,}$", "g");
          return {
            serializeContextData: a,
            serializeKeyValuePair: b,
            serializeParameters: c,
            isFunction: i,
            clone: g,
            append: h
          };
        })(),
        i = {};
      !(function(a) {
        "use strict";
        var b = function() {
          return (
            (this._ts = ADBMobile_platform.getTimeSince1970Millis()),
            (this._interval = null),
            (this._name = null),
            (this._enabled = !1),
            (this._nextTick = null),
            this
          );
        };
        (b.prototype.start = function(a, b) {
          this._enabled
            ? g.debug("Timer -  " + this._name + " timer already started.")
            : (g.debug(
                "Timer - starting " + b + " timer with interval (" + a + ")"
              ),
              (this._interval = a),
              (this._name = b),
              (this._ts = ADBMobile_platform.getTimeSince1970Millis()),
              (this._nextTick = this._interval),
              (this._enabled = !0));
        }),
          (b.prototype.stop = function() {
            this._enabled
              ? (g.debug("Timer - stoping " + this._name + " timer."),
                (this._enabled = !1),
                (this._nextTick = 0))
              : g.debug("Timer -  " + this._name + " timer already stopped.");
          }),
          (b.prototype.restartWithNewInterval = function(a) {
            g.debug(
              "Timer - restarting " +
                this._name +
                " timer with interval (" +
                a +
                ")"
            ),
              (this._interval = a),
              (this._ts = ADBMobile_platform.getTimeSince1970Millis()),
              (this._nextTick = this._interval),
              (this._enabled = !0);
          }),
          (b.prototype.reset = function() {
            g.debug("Timer - resetting " + this._name),
              (this._ts = ADBMobile_platform.getTimeSince1970Millis()),
              (this._nextTick = this._interval),
              (this._enabled = !0);
          }),
          (b.prototype.ticked = function() {
            var a = !1,
              b = ADBMobile_platform.getTimeSince1970Millis() - this._ts;
            return (
              b >= this._nextTick &&
                ((this._nextTick = b + this._interval), (a = !0)),
              a
            );
          }),
          (b.prototype.elapsedTime = function() {
            return ADBMobile_platform.getTimeSince1970Millis() - this._ts;
          }),
          (b.prototype.enabled = function() {
            return this._enabled;
          }),
          (a.Timer = b);
      })(i);
      var j = (function() {
          return { codeVersion: "cc-js-2.0.2.69-8039578", mediaAPILevel: 4 };
        })(),
        k = (function() {
          function a() {
            (l = ADBMobile_platform.readValue("adb_visitor_mid")),
              (m = ADBMobile_platform.readValue("adb_visitor_blob")),
              (n = ADBMobile_platform.readValue("adb_visitor_hint")),
              (o = ADBMobile_platform.readValue("adb_visitor_ttl")),
              (p = ADBMobile_platform.readValue("adb_visitor_sync"));
          }
          function b() {
            return "yxxxxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxxxxx"
              .replace(/[x]/g, function(a) {
                return "" + Math.floor(10 * Math.random());
              })
              .replace(/[y]/g, function(a) {
                return "" + Math.floor(9 * Math.random());
              });
          }
          function c(a, c) {
            if (
              (h.isFunction(c) || (c = function() {}),
              !e.visitorIDServiceEnabled())
            )
              return void c(null);
            if (e.getPrivacyStatus() !== e.PRIVACY_STATUS_OPT_IN)
              return (
                c(null),
                void g.debug(
                  "ID Service - Not syncing ID. Privacy is not set to opted in."
                )
              );
            var d = e.marketingCloudOrganizationIdentifier(),
              f = ADBMobile_platform.getTimeSince1970() - p > o;
            if (l && !a && !f) return void c(l);
            var i = e.ssl() ? "https" : "http";
            (i += "://dpm.demdex.net/id?d_rtbd=json&d_ver=2&d_orgid=" + d),
              m && (i += h.serializeKeyValuePair("d_blob", m)),
              l && (i += h.serializeKeyValuePair("d_mid", l)),
              n && (i += h.serializeKeyValuePair("dcs_region", n)),
              a &&
                Object.keys(a).forEach(function(a) {
                  i +=
                    "&d_cid_ic=" +
                    encodeURIComponent(a) +
                    "%01" +
                    encodeURIComponent(this[a]);
                }, a),
              g.debug("ID Service - Sending id sync call (" + i + ")"),
              ADBMobile_platform.httpRequestAsync(
                i,
                "GET",
                {},
                null,
                2e3,
                function(a, d) {
                  if (e.getPrivacyStatus() !== e.PRIVACY_STATUS_OPT_IN)
                    return void c(null);
                  if (200 == a)
                    if (d) {
                      g.debug(
                        "ID Service - Received received response from server (" +
                          d +
                          ")"
                      );
                      var f;
                      try {
                        f = JSON.parse(d);
                      } catch (h) {
                        f = null;
                      }
                      f
                        ? f.error_msg
                          ? g.error(
                              "ID Service - Error received from server(" +
                                f.error_msg +
                                ")"
                            )
                          : f.d_mid
                            ? ((l = f.d_mid),
                              (m = f.d_blob),
                              (n = f.dcs_region),
                              (o = f.id_sync_ttl || 0))
                            : ((l = b()), (m = null), (n = null), (o = 600))
                        : g.error(
                            "ID Service - Unable to parse response(" + d + ")"
                          );
                    } else
                      g.error("ID Service - Blank response from sync call");
                  else g.error("ID Service - Failed id sync call (" + a + ")");
                  (p = ADBMobile_platform.getTimeSince1970()),
                    ADBMobile_platform.writeValue("adb_visitor_mid", l),
                    ADBMobile_platform.writeValue("adb_visitor_blob", m),
                    ADBMobile_platform.writeValue("adb_visitor_hint", n),
                    ADBMobile_platform.writeValue("adb_visitor_ttl", o),
                    ADBMobile_platform.writeValue("adb_visitor_sync", p),
                    c(l);
                }
              );
          }
          function d(a) {
            if (h.isFunction(a))
              return e.visitorIDServiceEnabled()
                ? void c(null, a)
                : void a(null);
          }
          function f() {
            return l
              ? "?mid=" +
                  l +
                  "&mcorgid=" +
                  e.marketingCloudOrganizationIdentifier()
              : "";
          }
          function i() {
            var a = {};
            return l
              ? ((a.mid = l), m && (a.aamb = m), n && (a.aamlh = n), a)
              : a;
          }
          function j() {
            var a = "";
            return l
              ? ((a += h.serializeKeyValuePair("d_mid", l)),
                m && (a += h.serializeKeyValuePair("d_blob", m)),
                n && (a += h.serializeKeyValuePair("dcs_region", n)),
                a)
              : a;
          }
          function k() {
            (l = null),
              (m = null),
              (n = null),
              (o = null),
              (p = null),
              ADBMobile_platform.writeValue("adb_visitor_mid", ""),
              ADBMobile_platform.writeValue("adb_visitor_blob", ""),
              ADBMobile_platform.writeValue("adb_visitor_hint", ""),
              ADBMobile_platform.writeValue("adb_visitor_ttl", ""),
              ADBMobile_platform.writeValue("adb_visitor_sync", "");
          }
          var l, m, n, o, p;
          return {
            init: a,
            getMarketingCloudIDAsync: d,
            idSync: c,
            getAnalyticsParameters: i,
            getAnalyticsIDRequestParameterString: f,
            getAAMParameterString: j,
            purgeVisitorIdService: k
          };
        })(),
        l = (function() {
          function a(a) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN
              ? (g.debug("MediaHeartbeat - Queued Hit"),
                this._queue.push(a),
                f.call(this))
              : g.debug(
                  "MediaHeartbeat - Not queueing hit. Privacy is not set to optedin."
                );
          }
          function b(a) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN
              ? (g.debug("MediaHeartbeat - Queued Hit"),
                this._asyncQueue.push(a))
              : g.debug(
                  "MediaHeartbeat - Not queueing hit. Privacy is not set to optedin."
                );
          }
          function c() {
            if (this._asyncQueue.length > 0) {
              g.debug(
                "MediaHeartbeat - Flush requests. Pending requests:" +
                  this._asyncQueue.length
              );
              var a = function(a, b, c) {};
              for (var b in this._asyncQueue)
                if (this._asyncQueue.hasOwnProperty(b)) {
                  var c = i.call(this, this._asyncQueue[b]);
                  g.debug(
                    "MediaHeartbeat - Sending the Media Heartbeat Hit (" +
                      c +
                      ")"
                  ),
                    ADBMobile_platform.httpRequestAsync(
                      c,
                      "GET",
                      {},
                      "",
                      2e3,
                      a
                    );
                }
              this._asyncQueue = [];
            }
          }
          function d(a, b, c) {
            if (200 == a)
              if (
                (g.debug(
                  "MediaHeartbeat - Successfully sent hit with response data:" +
                    b
                ),
                b)
              ) {
                var d = ADBMobile_platform.parseXML(b),
                  e = {};
                g.debug("MediaHeartbeat - XML response (" + d + ")");
                var h = d.getElementsByTagName("trackingInterval");
                h &&
                  h.length > 0 &&
                  (e.trackingInterval = parseInt(
                    ADBMobile_platform.getBaseItem(h).textContent
                  )),
                  (h = d.getElementsByTagName("trackExternalErrors")),
                  h &&
                    h.length > 0 &&
                    (e.trackExternalErrors = parseInt(
                      ADBMobile_platform.getBaseItem(h).textContent
                    )),
                  (h = d.getElementsByTagName("setupCheckInterval")),
                  h &&
                    h.length > 0 &&
                    (e.setupCheckInterval = parseInt(
                      ADBMobile_platform.getBaseItem(h).textContent
                    )),
                  m.updateCheckStatusInterval(e);
              } else
                g.debug(
                  "MediaHeartbeat - Empty or invalid XML response received"
                );
            else
              g.error("MediaHeartbeat - Unable to send hit: " + c),
                g.debug("MediaHeartbeat - Response code " + a);
            (this._currentHit = null), f.call(this);
          }
          function f() {
            if (this._queue.length > 0 && !this._currentHit) {
              this._currentHit = this._queue.shift();
              var a = this,
                b = i.call(this, this._currentHit);
              g.debug(
                "MediaHeartbeat - Sending the Media Heartbeat Hit (" + b + ")"
              ),
                ADBMobile_platform.httpRequestAsync(
                  b,
                  "GET",
                  {},
                  "",
                  2e3,
                  function(b, c, e) {
                    d.call(a, b, c, e);
                  }
                );
            }
          }
          function i(a) {
            var b = !1;
            a.r && (b = !0);
            var c = h.serializeParameters(a);
            return c.length > 2 && (c = c.substring(1)), j.call(this, b) + c;
          }
          function j(a) {
            var b = "";
            if (e.mTrackingServer) {
              if (
                ((b = e.mSSL() ? "https" : "http"),
                (b = b + "://" + e.mTrackingServer()),
                a)
              ) {
                b = b + "/settings/" + e.mPublisher().replace(l, "-") + ".xml";
              }
              b += "?";
            }
            return b;
          }
          function k() {
            (this._asyncQueue = []),
              (this._queue = []),
              (this._currentHit = null);
          }
          var l = new RegExp("[^a-zA-Z0-9]+", "g");
          return {
            init: k,
            queueRequestsForResponse: a,
            queueAsyncRequest: b,
            flushAsyncRequests: c
          };
        })(),
        m = (function() {
          function a(a) {
            a.setupCheckInterval
              ? "number" == typeof a.setupCheckInterval
                ? (g.debug(
                    "ClockService -  updating the check status interval to: " +
                      a.setupCheckInterval
                  ),
                  (this._checkStatusInterval = 1e3 * a.setupCheckInterval),
                  this._checkStatusTimer.restartWithNewInterval(
                    this._checkStatusInterval
                  ))
                : g.debug(
                    "ClockService -  updateCheckStatusInterval: interval not an Integer"
                  )
              : g.debug(
                  "ClockService -  updateCheckStatusInterval: setupCheckInterval is invalid"
                );
          }
          function b() {
            return !!this._checkStatusTimer.ticked();
          }
          function c() {
            return !!this._reportingTimer.ticked();
          }
          function d() {
            return !!this._flushFilterTimer.ticked();
          }
          function e() {
            return !(
              !this._playheadTimer.enabled() || !this._playheadTimer.ticked()
            );
          }
          function f() {
            this._checkStatusTimer.start(
              this._checkStatusInterval,
              this._checkstatus_timer
            );
            var a = { r: ADBMobile_platform.getTimeSince1970() };
            l.queueRequestsForResponse(a),
              this._reportingTimer.start(
                this._reportingInterval,
                this._reporting_timer
              ),
              this._flushFilterTimer.start(
                this._flushFilterInterval,
                this._flushfilter_timer
              ),
              (this._active = !0),
              (this._intervalContext = this._intervalContext = ADBMobile_platform.setInterval(
                function() {
                  s.call(m);
                },
                250
              ));
          }
          function h() {
            l.flushAsyncRequests(),
              this.isActive() &&
                (this._checkStatusTimer.stop(),
                this._reportingTimer.stop(),
                this._flushFilterTimer.stop(),
                this._playheadTimer.stop(),
                (this._active = !1),
                ADBMobile_platform.clearInterval(this._intervalContext));
          }
          function j() {
            this._checkStatusTimer.reset(),
              this._reportingTimer.reset(),
              this._flushFilterTimer.reset();
          }
          function k() {
            return this._active;
          }
          function p(a) {
            return a == this._reporting_timer
              ? this._reportingTimer
              : a == this._checkstatus_timer
                ? this._checkStatusTimer
                : a == this._flushfilter_timer
                  ? this._flushFilterTimer
                  : a == this._playhead_timer
                    ? this._playheadTimer
                    : null;
          }
          function q() {
            this._playheadTimer.start(
              this._playheadInterval,
              this._playhead_timer
            );
          }
          function r() {
            this._playheadTimer.stop();
          }
          function s() {
            if (this.isActive()) {
              if (this.checkStatusTimerTick()) {
                g.debug("ClockServiceLoop - Check Status Timer Ticked");
                var a = { r: ADBMobile_platform.getTimeSince1970() };
                l.queueRequestsForResponse(a);
              }
              this.flushFilterTimerTick() && l.flushAsyncRequests(),
                this.reportingTimerTick() &&
                  (o.isSeeking()
                    ? g.debug(
                        "ClockServiceLoop - Reporting timer ticked but ADBMedia is in Seeking state."
                      )
                    : (g.debug("ClockServiceLoop - Reporting Timer Ticked"),
                      n._trackPlaybackState())),
                this.playheadTimerTick() && n._detectPlayheadStall();
            } else
              g.debug("ClockServiceLoop -  ClockService not initialized yet");
          }
          function t() {
            (this._ts = ADBMobile_platform.getTimeSince1970()),
              (this._checkStatusInterval = 6e4),
              (this._reportingInterval = 1e4),
              (this._flushFilterInterval = 250),
              (this._playheadInterval = 1e3),
              (this._active = !1),
              (this._reporting_timer = "ReportingTimer"),
              (this._checkstatus_timer = "CheckStatusTimer"),
              (this._flushfilter_timer = "FlushFilterTimer"),
              (this._playhead_timer = "PlayheadTimer");
            var a = i.Timer;
            (this._checkStatusTimer = new a()),
              (this._reportingTimer = new a()),
              (this._flushFilterTimer = new a()),
              (this._playheadTimer = new a());
          }
          return {
            updateCheckStatusInterval: a,
            checkStatusTimerTick: b,
            reportingTimerTick: c,
            flushFilterTimerTick: d,
            playheadTimerTick: e,
            startClockService: f,
            stopClockService: h,
            startPlayheadTimer: q,
            stopPlayheadTimer: r,
            resetClockService: j,
            isActive: k,
            getTimer: p,
            init: t
          };
        })(),
        n = (function() {
          function a(a, b, c, d) {
            var e = new ha();
            return (
              (e.name = a), (e.id = b), (e.length = c), (e.streamType = d), e
            );
          }
          function c(a, b, c, d) {
            var e = new ka();
            return (
              (e.name = a),
              (e.position = b),
              (e.startTime = c),
              (e.playerName = d),
              e
            );
          }
          function d(a, b, c, d) {
            var e = new ia();
            return (
              (e.name = a), (e.id = b), (e.position = c), (e.length = d), e
            );
          }
          function f(a, b, c, d) {
            var e = new ja();
            return (
              (e.name = a), (e.position = b), (e.length = c), (e.offset = d), e
            );
          }
          function i(a, b, c, d) {
            var e = new la();
            return (
              (e.bitrate = a),
              (e.startupTime = b),
              (e.fps = c),
              (e.droppedFrames = d),
              e
            );
          }
          function j() {
            m.init(),
              l.init(),
              p.init(),
              o.init(),
              (this._isEnabled = e.mediaHearbeatEnabled()),
              (this._isTrackingSuspended = !1),
              (this._previousPlayhead = -1),
              (this._stalledPlayheadCount = 0);
          }
          function k() {
            this._isEnabled = !0;
          }
          function q() {
            return this._isEnabled;
          }
          function r() {
            this._isEnabled = !1;
          }
          function s(a, b) {
            if ((g.debug("#_trackSessionStart()"), !o.getDelegate()))
              return (
                g.debug(
                  "trackSessionStart: Setting ADB Media module to error state as no delegate is set."
                ),
                void r.call(this)
              );
            D.call(this, a, b), C.call(this);
          }
          function t() {
            g.debug("#_trackSessionEnd()"), E.call(this);
          }
          function u() {
            g.debug("$_trackPlayheadStall()"),
              aa.call(this),
              o.setInStall(!0),
              o.resetAssetRefContext();
          }
          function v() {
            g.debug("#_trackPlayheadStallComplete()"),
              aa.call(this),
              o.setInStall(!1),
              o.resetAssetRefContext();
          }
          function w() {
            g.debug("$_resumeStallTracking()"), m.startPlayheadTimer();
          }
          function x() {
            g.debug("$_suspendStallTracking()"),
              m.stopPlayheadTimer(),
              o.setInStall(!1),
              (this._stalledPlayheadCount = 0);
          }
          function y() {
            if (q.call(this) && !o.isInAd()) {
              var a = o.getCurrentPlayhead();
              a != this._previousPlayhead
                ? ((this._stalledPlayheadCount = 0),
                  o.isInStall() && v.call(this))
                : this._previousPlayhead >= 0 &&
                  !o.isInStall() &&
                  ++this._stalledPlayheadCount >= ma &&
                  u.call(this),
                (this._previousPlayhead = a);
            }
          }
          function z() {
            g.debug("$_suspendTracking()"), (this._isTrackingSuspended = !0);
          }
          function A() {
            g.debug("$_resumeTracking()"), p.resetSessionIds();
            var a,
              b,
              c,
              d,
              e = null,
              f = !1;
            o.isInAd() &&
              ((d = !0),
              (a = o.getAdInfo()),
              (b = o.getAdContextData()),
              (c = o.getAdBreakInfo())),
              o.isInChapter() &&
                ((f = !0),
                (e = o.getChapterInfo()),
                (chapterData = o.getChapterContextData())),
              o.resetToResumeState(),
              B.call(this, !0),
              f &&
                (o.setInChapterTo(!0),
                o.setChapterInfo(e),
                o.setChapterContextData(chapterData),
                T.call(this)),
              d &&
                (o.setInAdTo(!0),
                o.setAdBreakInfo(c),
                o.setAdInfo(a),
                o.setAdContextData(b),
                X.call(this)),
              (this._isTrackingSuspended = !1);
          }
          function B(a) {
            g.debug("$_trackStartInternal()");
            var c = p.resolveDataForEvent(p._media_start);
            l.queueAsyncRequest(c);
            var d = p.getContextData("start");
            b.trackAction("", d);
            var e = p.resolveDataForEvent(p._aa_start);
            if ((l.queueAsyncRequest(e), a)) {
              var f = p.resolveDataForEvent("resume");
              l.queueAsyncRequest(f);
            }
          }
          function C() {
            if (
              (g.debug("#_trackStart()"),
              e.mediaHearbeatEnabled() && q.call(this))
            ) {
              m.startClockService();
              var a = o.getMediaInfo(),
                b = a && a[n.MediaObjectKey.VideoResumed];
              B.call(this, b), o.setActiveSession(!0), o.resetAssetRefContext();
            } else g.debug("trackStart: ADB Media module is in error state.");
          }
          function D(a, b) {
            if ((g.debug("#_trackLoad()"), e.mediaHearbeatEnabled())) {
              q.call(this) || k.call(this), o.setMediaInfo(a);
              var c = {};
              b && "object" == typeof b && h.append(c, b);
              var d =
                a && "object" == typeof a ? a[da.StandardVideoMetadata] : null;
              d && "object" == typeof d && h.append(c, d),
                o.setMediaContextData(c),
                o.isActiveTracking() &&
                  (g.warning("trackLoad: Resetting current tracking session."),
                  o.resetState()),
                o.setIsActiveTracking(!0);
            } else g.debug("trackLoad: ADB Media module is in error state.");
          }
          function E() {
            g.debug("#_trackUnload()"),
              o.isActiveTracking() ||
                g.debug("trackUnload: No active tracking session."),
              o.setIsActiveTracking(!1),
              o.setActiveSession(!1),
              o.resetState(),
              m.stopClockService();
          }
          function F() {
            g.debug("#_trackPlay()"),
              e.mediaHearbeatEnabled() && q.call(this)
                ? (aa.call(this),
                  o.setInPaused(!1),
                  o.resetAssetRefContext(),
                  G.call(this),
                  w.call(this))
                : g.debug("trackPlay: ADB Media module is in error state");
          }
          function G() {
            if (
              (g.debug("#_trackPlaybackState()"),
              e.mediaHearbeatEnabled() && q.call(this))
            ) {
              if (
                (o.isActiveSession() || C.call(this), this._isTrackingSuspended)
              ) {
                if (o.isVideoIdle())
                  return void g.debug(
                    "#_trackPlaybackState: [Video idle] Stays in suspendTracking"
                  );
                g.debug(
                  "#_trackPlaybackState: [Video resumes] suspendTracking -> resumeTracking"
                ),
                  A.call(this);
              }
              if (o.isVideoIdle() && o.getDurationSinceIdleState() > na)
                return (
                  g.debug(
                    "#_trackPlaybackState: [Video idle] Enters suspendTracking"
                  ),
                  void z.call(this)
                );
              var a = p.resolveDataForEvent(o.getCurrentPlaybackState());
              l.queueAsyncRequest(a), o.resetAssetRefContext();
            } else
              g.debug(
                "trackPlaybackState: ADB Media module is in error state."
              );
          }
          function H() {
            g.debug("#_trackPause()"),
              e.mediaHearbeatEnabled() && q.call(this)
                ? (aa.call(this),
                  x.call(this),
                  o.setInPaused(!0),
                  o.resetAssetRefContext(),
                  G.call(this))
                : g.debug("trackPause: ADB Media module is in error state.");
          }
          function I() {
            if (
              (g.debug("#_trackComplete()"),
              e.mediaHearbeatEnabled() && q.call(this))
            ) {
              aa.call(this), x.call(this);
              var a = p.resolveDataForEvent(p._media_complete);
              l.queueAsyncRequest(a);
            } else
              g.debug("trackComplete: ADB Media module is in error state.");
          }
          function J(a, b) {
            g.debug("#_trackError(" + a + "," + b + ")");
            var c = p.resolveDataForEvent(p._error);
            (c["s:event:source"] = b),
              (c["s:event:id"] = a),
              l.queueAsyncRequest(c);
          }
          function K(a, b, c) {
            g.debug("#_trackMediaEvent(" + a + ")"),
              e.mediaHearbeatEnabled() && q.call(this)
                ? a == ca.BufferStart
                  ? P.call(this)
                  : a == ca.BufferComplete
                    ? Q.call(this)
                    : a == ca.SeekStart
                      ? R.call(this)
                      : a == ca.SeekComplete
                        ? S.call(this)
                        : a == ca.BitrateChange
                          ? _.call(this)
                          : a == ca.ChapterStart
                            ? U.call(this, b, c)
                            : a == ca.ChapterComplete
                              ? V.call(this)
                              : a == ca.ChapterSkip
                                ? W.call(this)
                                : a == ca.AdBreakStart
                                  ? M.call(this, b)
                                  : a == ca.AdBreakComplete
                                    ? N.call(this)
                                    : a == ca.AdBreakSkip
                                      ? O.call(this)
                                      : a == ca.AdStart
                                        ? Y.call(this, b, c)
                                        : a == ca.AdComplete
                                          ? Z.call(this)
                                          : a == ca.AdSkip
                                            ? $.call(this)
                                            : g.debug(
                                                "trackMediaEvent: Unknown media event: " +
                                                  a
                                              )
                : g.debug(
                    "trackMediaEvent: ADB Media module is in error state."
                  );
          }
          function L(a) {
            e.mediaHearbeatEnabled()
              ? o.setDelegate(a)
              : g.debug("setDelegate: ADB Media module is in error state.");
          }
          function M(a) {
            g.debug("#_trackAdBreakStart()"), o.setAdBreakInfo(a);
          }
          function N() {
            g.debug("#_trackAdBreakComplete()"), o.setAdBreakInfo(null);
          }
          function O() {
            g.debug("#_trackAdBreakSkip()"), o.setAdBreakInfo(null);
          }
          function P() {
            g.debug("#_trackBufferStart()"),
              aa.call(this),
              x.call(this),
              o.setInBuffering(!0),
              o.resetAssetRefContext(),
              G.call(this);
          }
          function Q() {
            g.debug("#_trackBufferComplete()"),
              aa.call(this),
              o.setInBuffering(!1),
              o.resetAssetRefContext(),
              G.call(this),
              o.isPlaying() && w.call(this);
          }
          function R() {
            g.debug("#_trackSeekStart()"),
              aa.call(this),
              x.call(this),
              o.setInSeeking(!0);
          }
          function S() {
            if ((g.debug("#_trackSeekComplete()"), o.isSeeking())) {
              var a = m.getTimer(m._reporting_timer);
              a && a.reset(), o.setInSeeking(!1), o.isPlaying() && w.call(this);
            } else
              g.warning(
                "trackMediaEvent: SEEK_COMPLETE - Not in seek state, nothing to do."
              );
          }
          function T() {
            g.debug("#_trackChapterStartInternal()");
            var a = p.resolveDataForEvent(p._chapter_start);
            l.queueAsyncRequest(a);
          }
          function U(a, b) {
            g.debug("#_trackChapterStart()"),
              aa.call(this),
              o.setInChapterTo(!0),
              o.setChapterInfo(a),
              o.setChapterContextData(b),
              T.call(this),
              o.resetAssetRefContext(),
              o.isPlaying() && G.call(this);
          }
          function V() {
            g.debug("#_trackChapterComplete()"), aa.call(this);
            var a = p.resolveDataForEvent(p._chapter_complete);
            l.queueAsyncRequest(a),
              o.setInChapterTo(!1),
              o.setChapterInfo(null),
              o.setChapterContextData(null),
              o.resetAssetRefContext();
          }
          function W() {
            g.debug("#_trackChapterSkip()"),
              o.setInChapterTo(!1),
              o.setChapterInfo(null),
              o.setChapterContextData(null);
          }
          function X() {
            g.debug("#_trackAdStartInternal()");
            var a = p.resolveDataForEvent(p._ad_start);
            l.queueAsyncRequest(a);
            var c = p.getContextData("ad-start");
            b.trackAction("", c);
            var d = p.resolveDataForEvent(p._aa_ad_start);
            l.queueAsyncRequest(d);
          }
          function Y(a, b) {
            g.debug("#_trackAdStart()"),
              aa.call(this),
              o.setInAdTo(!0),
              o.setAdInfo(a);
            var c = {};
            b && "object" == typeof b && h.append(c, b);
            var d = a && "object" == typeof a ? a[da.StandardAdMetadata] : null;
            d && "object" == typeof d && h.append(c, d),
              o.setAdContextData(c),
              X.call(this),
              o.resetAssetRefContext(),
              o.isPlaying() && G.call(this);
          }
          function Z() {
            g.debug("#_trackAdComplete()"), aa.call(this);
            var a = p.resolveDataForEvent(p._ad_complete);
            l.queueAsyncRequest(a),
              o.setInAdTo(!1),
              o.setAdContextData(null),
              o.setAdInfo(null),
              o.resetAssetRefContext();
          }
          function $() {
            g.debug("#_trackAdSkip()"),
              o.setInAdTo(!1),
              o.setAdInfo(null),
              o.setAdContextData(null);
          }
          function _() {
            g.debug("#_trackBitrateChange()");
            var a = p.resolveDataForEvent(p._bitrate_change);
            l.queueAsyncRequest(a);
          }
          function aa() {
            var a = m.getTimer(m._reporting_timer);
            a && a.elapsedTime() > 250 && (G.call(this), a.reset());
          }
          var ba = {
              SourceApplication: "sourceErrorExternal",
              SourcePlayer: "sourceErrorSDK"
            },
            ca = {
              AdBreakStart: "adBreakStart",
              AdBreakComplete: "adBreakComplete",
              AdBreakSkip: "adBreakSkip",
              AdStart: "adStart",
              AdComplete: "adComplete",
              AdSkip: "adSkip",
              ChapterStart: "chapterStart",
              ChapterComplete: "chapterComplete",
              ChapterSkip: "chapterSkip",
              SeekStart: "seekStart",
              SeekComplete: "seekComplete",
              BufferStart: "bufferStart",
              BufferComplete: "bufferComplete",
              BitrateChange: "bitrateChange"
            },
            da = {
              StandardVideoMetadata: "media_standard_content_metadata",
              StandardAdMetadata: "media_standard_ad_metadata",
              VideoResumed: "resumed"
            },
            ea = { VOD: "vod", LIVE: "live", LINEAR: "linear" },
            fa = {
              SHOW: "a.media.show",
              SEASON: "a.media.season",
              EPISODE: "a.media.episode",
              ASSET_ID: "a.media.asset",
              GENRE: "a.media.genre",
              FIRST_AIR_DATE: "a.media.airDate",
              FIRST_DIGITAL_DATE: "a.media.digitalDate",
              RATING: "a.media.rating",
              ORIGINATOR: "a.media.originator",
              NETWORK: "a.media.network",
              SHOW_TYPE: "a.media.type",
              AD_LOAD: "a.media.adLoad",
              MVPD: "a.media.pass.mvpd",
              AUTHORIZED: "a.media.pass.auth",
              DAY_PART: "a.media.dayPart",
              FEED: "a.media.feed",
              STREAM_FORMAT: "a.media.format"
            },
            ga = {
              ADVERTISER: "a.media.ad.advertiser",
              CAMPAIGN_ID: "a.media.ad.campaign",
              CREATIVE_ID: "a.media.ad.creative",
              PLACEMENT_ID: "a.media.ad.placement",
              SITE_ID: "a.media.ad.site",
              CREATIVE_URL: "a.media.ad.creativeURL"
            },
            ha = function() {
              (this.id = ""),
                (this.name = ""),
                (this.length = 0),
                (this.streamType = ea.VOD);
            },
            ia = function() {
              (this.id = ""),
                (this.name = ""),
                (this.length = 0),
                (this.position = 0);
            },
            ja = function() {
              (this.name = ""),
                (this.length = 0),
                (this.position = 0),
                (this.offset = 0);
            },
            ka = function() {
              (this.name = null),
                (this.startTime = null),
                (this.position = 0),
                (this.playerName = null);
            },
            la = function() {
              (this.bitrate = 0),
                (this.fps = 0),
                (this.droppedFrames = 0),
                (this.startupTime = 0);
            },
            ma = 2,
            na = 18e5,
            oa = {
              init: function() {
                j.call(n);
              },
              enable: function() {
                k.call(n);
              },
              isEnabled: function() {
                return q.call(n);
              },
              disable: function() {
                r.call(n);
              },
              trackSessionStart: function(a, b) {
                s.call(n, a, b);
              },
              trackSessionEnd: function() {
                t.call(this);
              },
              trackStart: function() {
                C.call(n);
              },
              trackLoad: function(a, b) {
                D.call(n, a, b);
              },
              trackUnload: function() {
                E.call(n);
              },
              trackPlay: function() {
                F.call(n);
              },
              trackPause: function() {
                H.call(n);
              },
              trackComplete: function() {
                I.call(n);
              },
              trackError: function(a) {
                J.call(n, a || "unknown_error_id", ba.SourcePlayer);
              },
              trackEvent: function(a, b, c) {
                K.call(n, a, b, c);
              },
              setDelegate: function(a) {
                L.call(n, a);
              },
              _trackPlaybackState: function() {
                G.call(n);
              },
              _detectPlayheadStall: function() {
                y.call(n);
              }
            };
          return (
            (oa.StreamType = ea),
            (oa.Event = ca),
            (oa.MediaObjectKey = da),
            (oa.VideoMetadataKeys = fa),
            (oa.AdMetadataKeys = ga),
            (oa.Error = ba),
            (oa.createMediaObject = a),
            (oa.createAdBreakObject = c),
            (oa.createChapterObject = f),
            (oa.createAdObject = d),
            (oa.createQoSObject = i),
            (oa.MediaInfo = ha),
            (oa.AdInfo = ia),
            (oa.ChapterInfo = ja),
            (oa.AdBreakInfo = ka),
            (oa.QoSInfo = la),
            oa
          );
        })(),
        o = (function() {
          function b() {
            (this.delegate = null), this.resetState();
          }
          function c(a) {
            this.isInAdValue = a;
          }
          function d(a) {
            this._isActiveTrackingValue = a;
          }
          function f(a) {
            this.isInChapterValue = a;
          }
          function h() {
            return this._isActiveTrackingValue;
          }
          function i(a) {
            (this._isBufferingValue = a), X.call(this);
          }
          function j() {
            return this._isBufferingValue;
          }
          function l(a) {
            (this._isPausedValue = a),
              a || (this._isPlayStartedValue = !0),
              X.call(this);
          }
          function m() {
            return this._isPausedValue;
          }
          function o() {
            return !this._isPausedValue && this._isPlayStartedValue;
          }
          function r(a) {
            (this._isSeekingValue = a), X.call(this);
          }
          function s() {
            return this._isSeekingValue;
          }
          function t(a) {
            (this._isInStallValue = a), X.call(this);
          }
          function u() {
            return this._isInStallValue;
          }
          function v() {
            return this.isInAdValue;
          }
          function w() {
            return this.isInChapterValue;
          }
          function x() {
            return this._isSessionActive;
          }
          function y(a) {
            this._isSessionActive = a;
          }
          function z() {
            var a = this.currMediaInfo;
            return (
              a
                ? q.isValidMediaInfoObject(a) ||
                  (g.warning("Media - MediaInfo object is not valid"),
                  (a = null))
                : g.warning("Media - MediaInfo object not set."),
              a
            );
          }
          function A() {
            var a = this.currAdBreakInfo;
            return (
              a
                ? q.isValidAdBreakInfoObject(a) ||
                  (g.warning("Media - AdBreakInfo object is not valid"),
                  (a = new n.AdBreakInfo()),
                  (a._isEmptyAdBreak = !0))
                : (g.warning("Media - AdBreakInfo object not set."),
                  (a = new n.AdBreakInfo()),
                  (a._isEmptyAdBreak = !0)),
              a
            );
          }
          function B() {
            var a = this.currAdInfo;
            return (
              a
                ? q.isValidAdInfoObject(a) ||
                  (g.warning("Media - AdInfo object is not valid"), (a = null))
                : g.warning("Media - AdInfo object not set."),
              a
            );
          }
          function C() {
            var a = this.currChapterInfo;
            return (
              a
                ? q.isValidChapterInfoObject(a) ||
                  (g.warning("Media - ChapterInfo object is not valid"),
                  (a = null))
                : g.warning("Media - ChapterInfo object not set."),
              a
            );
          }
          function D() {
            var a;
            return (
              this.delegate && "function" == typeof this.delegate.getQoSObject
                ? (a = this.delegate.getQoSObject())
                : this.delegate &&
                  "function" == typeof this.delegate.getQoSInfo &&
                  (a = this.delegate.getQoSInfo()),
              a
                ? q.isValidQoSInfoObject(a) ||
                  (g.warning("Media - QoSInfo object is not valid"), (a = null))
                : g.warning("Media - QoSInfo object not set."),
              a
            );
          }
          function E() {
            var a = this.currMediaContextData;
            return a || g.debug("Media - Media context data is not set."), a;
          }
          function F() {
            var a = this.currChapterContextData;
            return a || g.debug("Media - Chapter context data is not set."), a;
          }
          function G() {
            var a = this.currAdContextData;
            return a || g.debug("Media - Ad context data is not set."), a;
          }
          function H(a) {
            this.currMediaInfo = a;
          }
          function I(a) {
            this.currAdBreakInfo = a;
          }
          function J(a) {
            this.currAdInfo = a;
          }
          function K(a) {
            this.currChapterInfo = a;
          }
          function L(a) {
            this.currMediaContextData = a;
          }
          function M(a) {
            this.currAdContextData = a;
          }
          function N(a) {
            this.currChapterContextData = a;
          }
          function O() {
            (this.eventTSMap = {}),
              (this.assetRefContext = {}),
              this.setInAdTo(!1),
              this.setAdInfo(null),
              this.setAdContextData(null),
              this.setInChapterTo(!1),
              this.setChapterInfo(null),
              this.setChapterContextData(null),
              this.setAdBreakInfo(null);
          }
          function P() {
            this.setIsActiveTracking(!1),
              this.setActiveSession(!1),
              (this._isPlayStartedValue = !1),
              (this._isBufferingValue = !1),
              (this._isInStallValue = !1),
              (this._isPausedValue = !1),
              (this._isSeekingValue = !1),
              (this._isVideoIdleValue = !1),
              (this._idleStateTS = ADBMobile_platform.getTimeSince1970Millis()),
              (this._playhead = 0),
              (this.mid = null),
              (this.mid_start = !1),
              (this.aid = null),
              (this.aid_start = !1),
              this.setMediaInfo(null),
              this.setMediaContextData(null),
              O.call(this),
              p.resetSessionIds();
          }
          function Q() {
            (this.assetRefContext.state = W.call(this)),
              (this.assetRefContext.ts = ADBMobile_platform.getTimeSince1970Millis()),
              (this.assetRefContext.playhead = this._playhead);
          }
          function R() {
            return this.assetRefContext;
          }
          function S(a, b) {
            this.eventTSMap[a] = b;
          }
          function T(a) {
            a &&
            (!a ||
              "function" != typeof a.getCurrentPlaybackTime ||
              ("function" != typeof a.getQoSInfo &&
                "function" != typeof a.getQoSObject))
              ? g.error(
                  "Media - setDelegate error. The delegate object is required to have the following functions: getCurrentPlaybackTime, getQoSInfo"
                )
              : (this.delegate = a);
          }
          function U() {
            return this.delegate;
          }
          function V() {
            return this.delegate
              ? ((this._playhead = this.delegate.getCurrentPlaybackTime()),
                this._playhead)
              : (g.error(
                  "Media - Please set the media delegate before starting the video tracking."
                ),
                -1);
          }
          function W() {
            return this.isInStall()
              ? p._player_event_stall
              : this.isBuffering()
                ? p._player_event_buffer
                : this.isPaused() || this.isSeeking()
                  ? p._player_event_pause
                  : this.isPlaying()
                    ? p._player_event_play
                    : p._player_event_start;
          }
          function X() {
            var a =
              this.isPaused() ||
              this.isBuffering() ||
              this.isSeeking() ||
              this.isInStall();
            a != this.isVideoIdle() &&
              (this._idleStateTS = ADBMobile_platform.getTimeSince1970Millis()),
              (this._isVideoIdleValue = a);
          }
          function Y() {
            if (this.isVideoIdle()) {
              var a = this._idleStateTS;
              return ADBMobile_platform.getTimeSince1970Millis() - a;
            }
            return 0;
          }
          function Z() {
            return this._isVideoIdleValue;
          }
          function $(a) {
            return (
              this.eventTSMap[a] || (this.eventTSMap[a] = "-1"),
              this.eventTSMap[a]
            );
          }
          function _() {
            if (!this.mid_start) {
              var a = this;
              (this.mid_start = !0),
                k.getMarketingCloudIDAsync(function(b) {
                  a.mid = b;
                });
            }
            return this.mid;
          }
          function aa() {
            if (!this.aid_start) {
              var b = this;
              (this.aid_start = !0),
                a.getAIDAsync(function(a) {
                  b.aid = a;
                });
            }
            return this.aid;
          }
          function ba() {
            return e.getUserIdentifier();
          }
          return {
            init: b,
            setInAdTo: c,
            setIsActiveTracking: d,
            setInChapterTo: f,
            isActiveTracking: h,
            isPaused: m,
            isPlaying: o,
            isSeeking: s,
            isBuffering: j,
            isInStall: u,
            isInAd: v,
            isInChapter: w,
            isActiveSession: x,
            setActiveSession: y,
            setInPaused: l,
            setInSeeking: r,
            setInBuffering: i,
            setInStall: t,
            getMediaInfo: z,
            getAdBreakInfo: A,
            getAdInfo: B,
            getChapterInfo: C,
            getQoSInfo: D,
            getMediaContextData: E,
            getChapterContextData: F,
            getAdContextData: G,
            setMediaInfo: H,
            setAdBreakInfo: I,
            setAdInfo: J,
            setChapterInfo: K,
            setMediaContextData: L,
            setAdContextData: M,
            setChapterContextData: N,
            resetState: P,
            resetToResumeState: O,
            resetAssetRefContext: Q,
            updateTimeStampForEvent: S,
            getCurrentPlayhead: V,
            getCurrentPlaybackState: W,
            getAssetRefContext: R,
            getTimeStampForEvent: $,
            getDurationSinceIdleState: Y,
            isVideoIdle: Z,
            getVisitorID: _,
            getAdobeAnalyticsID: aa,
            getUserID: ba,
            setDelegate: T,
            getDelegate: U
          };
        })(),
        p = (function() {
          function a() {
            var a = {};
            return (
              (a[this._analytics_rsid] = null),
              (a[this._analytics_trackingserver] = null),
              (a[this._analytics_ssl] = null),
              (a[this._user_aid] = null),
              (a[this._user_mid] = null),
              (a[this._user_vid] = null),
              (a[this._cuser_id] = null),
              (a[this._cuser_puuid] = null),
              (a[this._service_ovp] = null),
              (a[this._service_sdk] = null),
              (a[this._service_channel] = null),
              (a[this._service_playername] = null),
              (a[this._service_hbversion] = null),
              (a[this._service_apilevel] = null),
              (a[this._event_sid] = null),
              (a[this._event_type] = null),
              (a[this._event_duration] = null),
              (a[this._event_playhead] = null),
              (a[this._event_ts] = null),
              (a[this._event_prevts] = null),
              (a[this._asset_type] = null),
              (a[this._asset_mediaid] = null),
              (a[this._asset_publisher] = null),
              (a[this._asset_length] = null),
              (a[this._asset_name] = null),
              (a[this._asset_adid] = null),
              (a[this._asset_adsid] = null),
              (a[this._asset_adname] = null),
              (a[this._asset_adlength] = null),
              (a[this._asset_resolver] = null),
              (a[this._asset_podid] = null),
              (a[this._asset_podposition] = null),
              (a[this._asset_podname] = null),
              (a[this._asset_podoffset] = null),
              (a[this._stream_chapterid] = null),
              (a[this._stream_chaptersid] = null),
              (a[this._stream_chaptername] = null),
              (a[this._stream_chapterpos] = null),
              (a[this._stream_chapterlength] = null),
              (a[this._stream_chapteroffset] = null),
              (a[this._stream_type] = null),
              (a[this._stream_bitrate] = null),
              (a[this._stream_fps] = null),
              (a[this._stream_droppedFrames] = null),
              (a[this._stream_startup_time] = null),
              a
            );
          }
          function b(b) {
            var c = a.call(this);
            return (
              n.call(this, c),
              p.call(this, c),
              q.call(this, c),
              r.call(this, c),
              t.call(this, c),
              s.call(this, c),
              (c[this._event_sid] = D.call(this)),
              b == this._aa_start
                ? (u.call(this, c, b), l.call(this, c))
                : b == this._aa_ad_start
                  ? u.call(this, c, b)
                  : b == this._media_start
                    ? (u.call(this, c, "start"), z.call(this, c))
                    : b == this._ad_start
                      ? ((this._adSessionIdValue = null),
                        u.call(this, c, "start"),
                        z.call(this, c))
                      : b == this._ad_complete
                        ? u.call(this, c, "complete")
                        : b == this._chapter_start
                          ? ((this._chapterSessionIdValue = null),
                            u.call(this, c, b),
                            z.call(this, c))
                          : b == this._chapter_complete
                            ? u.call(this, c, b)
                            : b == this._bitrate_change
                              ? u.call(this, c, b)
                              : b == this._media_complete
                                ? (u.call(this, c, "complete"),
                                  (this._mediaSessionIdValue = null))
                                : u.call(this, c, b),
              o.isInAd() && x.call(this, c),
              o.isInChapter() && y.call(this, c),
              v.call(this, c, b),
              w.call(this, c, b),
              c
            );
          }
          function c(a) {
            var b,
              c,
              f = {};
            if ("start" == a)
              (b = o.getMediaContextData()),
                b && h.append(f, b),
                (c = o.getMediaInfo()),
                (f["a.contentType"] = c.streamType),
                (f["a.media.name"] = c.id),
                (f["a.media.friendlyName"] = c.name),
                (f["a.media.length"] = Math.floor(c.length) || "0"),
                (f["a.media.playerName"] = e.mPlayerName()),
                (f["a.media.channel"] = e.mChannel()),
                (f["a.media.vsid"] = D.call(this)),
                (f["a.media.view"] = "true"),
                (f["&&pev3"] = "video"),
                (f["&&pe"] = "ms_s"),
                d.getDpid() && (f["&&cid.userId.id"] = d.getDpid()),
                d.getDpuuid() && (f["&&cid.puuid.id"] = d.getDpuuid());
            else if ("ad-start" == a) {
              b = o.getMediaContextData();
              var g = o.getAdContextData();
              b && h.append(f, b), g && h.append(f, g), (c = o.getMediaInfo());
              var j = o.getAdInfo(),
                k = o.getAdBreakInfo(),
                l = i.md5(c.id),
                m = l + "_" + (k.position || ""),
                n =
                  void 0 === k.startTime ? o.getCurrentPlayhead() : k.startTime;
              (f["a.contentType"] = c.streamType),
                (f["a.media.name"] = c.id),
                (f["a.media.friendlyName"] = c.name),
                (f["a.media.length"] = Math.floor(c.length) || "0"),
                (f["a.media.playerName"] = e.mPlayerName()),
                (f["a.media.channel"] = e.mChannel()),
                (f["a.media.vsid"] = D.call(this)),
                (f["a.media.ad.name"] = j.id),
                (f["a.media.ad.friendlyName"] = j.name),
                (f["a.media.ad.podFriendlyName"] = k.name || ""),
                (f["a.media.ad.length"] = Math.floor(j.length) || "0"),
                (f["a.media.ad.playerName"] = k.playerName || e.mPlayerName()),
                (f["a.media.ad.pod"] = m),
                (f["a.media.ad.podPosition"] = Math.floor(j.position) || "0"),
                (f["a.media.ad.podSecond"] = Math.floor(n) || "0"),
                (f["a.media.ad.view"] = !0),
                (f["&&pev3"] = "videoAd"),
                (f["&&pe"] = "msa_s"),
                d.getDpid() && (f["&&cid.userId.id"] = d.getDpid()),
                d.getDpuuid() && (f["&&cid.puuid.id"] = d.getDpuuid());
            }
            return f;
          }
          function f() {
            (this._mediaSessionIdValue = null),
              (this._adSessionIdValue = null),
              (this._chapterSessionIdValue = null);
          }
          function l(a) {
            d.getDpid() && (a[this._cuser_id] = d.getDpid()),
              d.getDpuuid() && (a[this._cuser_puuid] = d.getDpuuid());
          }
          function n(a) {
            (a[this._analytics_rsid] = e.reportSuiteIDs()),
              (a[this._analytics_trackingserver] = e.trackingServer()),
              e.ssl()
                ? (a[this._analytics_ssl] = 1)
                : (a[this._analytics_ssl] = 0);
          }
          function p(a) {
            (a[this._user_aid] = o.getAdobeAnalyticsID()),
              (a[this._user_mid] = o.getVisitorID()),
              (a[this._user_vid] = o.getUserID());
          }
          function q(a) {
            var b = k.getAnalyticsParameters();
            b &&
              (b.aamb && (a[this._aam_blob] = b.aamb),
              b.aamlh && (a[this._aam_loc_hint] = b.aamlh));
          }
          function r(a) {
            (a[this._service_ovp] = e.mOVP()),
              (a[this._service_sdk] = e.mSDK()),
              (a[this._service_channel] = e.mChannel()),
              (a[this._service_playername] = e.mPlayerName()),
              (a[this._service_hbversion] = j.codeVersion),
              (a[this._service_apilevel] = j.mediaAPILevel);
          }
          function s(a) {
            var b = o.getMediaInfo();
            b && (a[this._stream_type] = b.streamType);
            var c = o.getQoSInfo();
            if (c) {
              var d = Number(c.droppedFrames),
                e = Number(c.startupTime),
                f = Number(c.fps),
                g = Number(c.bitrate);
              isNaN(d) || (a[this._stream_droppedFrames] = Math.floor(d)),
                isNaN(e) || (a[this._stream_startup_time] = Math.floor(e)),
                isNaN(f) || (a[this._stream_fps] = Math.floor(f)),
                isNaN(g) || (a[this._stream_bitrate] = Math.floor(g));
            }
          }
          function t(a) {
            var b = o.getMediaInfo();
            (a[this._asset_type] = "main"),
              b &&
                ((a[this._asset_mediaid] = b.id),
                (a[this._asset_length] = Math.floor(b.length)),
                (a[this._asset_name] = b.name)),
              (a[this._asset_publisher] = e.mPublisher());
          }
          function u(a, b) {
            var c = o.getCurrentPlayhead();
            "number" == typeof c && (a[this._event_playhead] = Math.floor(c)),
              (a[this._event_type] = b);
          }
          function v(a, b) {
            var c = b;
            if (o.isInAd()) {
              c = o.getAdInfo().id + "_" + b;
            }
            var d = ADBMobile_platform.getTimeSince1970Millis(),
              e = o.getTimeStampForEvent(c);
            (a[this._event_prevts] = e),
              (a[this._event_ts] = d),
              o.updateTimeStampForEvent(c, d);
          }
          function w(a, b) {
            var c = o.getAssetRefContext(),
              d = 0,
              e = a[this._event_ts],
              f = a[this._event_playhead];
            if (
              c.state === b &&
              ((d = e - c.ts),
              b !== this._player_event_pause && b !== this._player_event_stall)
            ) {
              var h = f - c.playhead,
                i = e - c.ts;
              (h > i * I || i > m._reportingInterval * I) &&
                (g.warning(
                  "Setting event duration to 0. playheadDelta:" +
                    h +
                    " tsDelta:" +
                    i +
                    " event type:" +
                    b
                ),
                (d = 0));
            }
            a[this._event_duration] = d;
          }
          function x(a) {
            a[this._asset_type] = "ad";
            var b = o.getAdBreakInfo();
            if (b && !b._isEmptyAdBreak) {
              (a[this._asset_resolver] = b.playerName || e.mPlayerName()),
                (a[this._asset_podposition] = b.position),
                (a[this._asset_podname] = b.name),
                (a[this._asset_podoffset] = Math.floor(b.startTime));
              var c = i.md5(a[this._asset_mediaid]);
              a[this._asset_podid] = c + "_" + a[this._asset_podposition];
            }
            var d = o.getAdInfo();
            d &&
              ((a[this._asset_adid] = d.id),
              (a[this._asset_adname] = d.name),
              (a[this._asset_adlength] = Math.floor(d.length))),
              (a[this._asset_adsid] = F.call(this));
          }
          function y(a) {
            a[this._stream_chaptersid] = E.call(this);
            var b = o.getChapterInfo();
            if (b) {
              a[this._stream_chapterpos] = b.position;
              var c = i.md5(a[this._asset_mediaid]);
              (a[this._stream_chapterid] =
                c + "_" + a[this._stream_chapterpos]),
                (a[this._stream_chaptername] = b.name),
                (a[this._stream_chapteroffset] = Math.floor(b.offset)),
                (a[this._stream_chapterlength] = Math.floor(b.length));
            }
          }
          function z(a) {
            A.call(this, a),
              o.isInAd() && B.call(this, a),
              o.isInChapter() && C.call(this, a);
          }
          function A(a) {
            var b = o.getMediaContextData();
            if (b)
              for (var c in b)
                if (b.hasOwnProperty(c)) {
                  var d = this.metaKey + c;
                  a[d] = b[c];
                }
          }
          function B(a) {
            var b = o.getAdContextData();
            if (b)
              for (var c in b)
                if (b.hasOwnProperty(c)) {
                  var d = this.metaKey + c;
                  a[d] = b[c];
                }
          }
          function C(a) {
            var b = o.getChapterContextData();
            if (b)
              for (var c in b)
                if (b.hasOwnProperty(c)) {
                  var d = this.metaKey + c;
                  a[d] = b[c];
                }
          }
          function D() {
            return (
              this._mediaSessionIdValue ||
                (this._mediaSessionIdValue = G.call(this)),
              this._mediaSessionIdValue
            );
          }
          function E() {
            return (
              this._chapterSessionIdValue ||
                (this._chapterSessionIdValue = G.call(this)),
              this._chapterSessionIdValue
            );
          }
          function F() {
            return (
              this._adSessionIdValue || (this._adSessionIdValue = G.call(this)),
              this._adSessionIdValue
            );
          }
          function G() {
            return (
              "" +
              ADBMobile_platform.getTimeSince1970Millis() +
              Math.floor(1e9 * Math.random() + 1)
            );
          }
          function H() {
            (this._analytics_rsid = "s:sc:rsid"),
              (this._analytics_trackingserver = "s:sc:tracking_server"),
              (this._analytics_ssl = "h:sc:ssl"),
              (this._user_aid = "s:user:aid"),
              (this._user_mid = "s:user:mid"),
              (this._user_vid = "s:user:id"),
              (this._aam_blob = "s:aam:blob"),
              (this._aam_loc_hint = "l:aam:loc_hint"),
              (this._cuser_id = "s:cuser:userId.id"),
              (this._cuser_puuid = "s:cuser:puuid.id"),
              (this._service_sdk = "s:sp:sdk"),
              (this._service_apilevel = "l:sp:hb_api_lvl"),
              (this._service_channel = "s:sp:channel"),
              (this._service_ovp = "s:sp:ovp"),
              (this._service_playername = "s:sp:player_name"),
              (this._service_hbversion = "s:sp:hb_version"),
              (this._asset_type = "s:asset:type"),
              (this._asset_publisher = "s:asset:publisher"),
              (this._asset_mediaid = "s:asset:video_id"),
              (this._asset_length = "l:asset:length"),
              (this._asset_name = "s:asset:name"),
              (this._stream_type = "s:stream:type"),
              (this._stream_droppedFrames = "l:stream:dropped_frames"),
              (this._stream_startup_time = "l:stream:startup_time"),
              (this._stream_fps = "l:stream:fps"),
              (this._stream_bitrate = "l:stream:bitrate"),
              (this._stream_chaptersid = "s:stream:chapter_sid"),
              (this._stream_chapterid = "s:stream:chapter_id"),
              (this._stream_chaptername = "s:stream:chapter_name"),
              (this._stream_chapteroffset = "l:stream:chapter_offset"),
              (this._stream_chapterpos = "l:stream:chapter_pos"),
              (this._stream_chapterlength = "l:stream:chapter_length"),
              (this._asset_resolver = "s:asset:resolver"),
              (this._asset_adid = "s:asset:ad_id"),
              (this._asset_adsid = "s:asset:ad_sid"),
              (this._asset_adname = "s:asset:ad_name"),
              (this._asset_adlength = "l:asset:ad_length"),
              (this._asset_podid = "s:asset:pod_id"),
              (this._asset_podposition = "s:asset:pod_position"),
              (this._asset_podname = "s:asset:pod_name"),
              (this._asset_podoffset = "l:asset:pod_offset"),
              (this._event_sid = "s:event:sid"),
              (this._event_ts = "l:event:ts"),
              (this._event_prevts = "l:event:prev_ts"),
              (this._event_type = "s:event:type"),
              (this._event_duration = "l:event:duration"),
              (this._event_playhead = "l:event:playhead"),
              (this._mediaSessionIdValue = null),
              (this._chapterSessionIdValue = null),
              (this._adSessionIdValue = null),
              (this.metaKey = "s:meta:"),
              (this._aa_start = "aa_start"),
              (this._aa_ad_start = "aa_ad_start"),
              (this._bitrate_change = "bitrate_change"),
              (this._chapter_start = "chapter_start"),
              (this._chapter_complete = "chapter_complete"),
              (this._ad_start = "media-ad-start"),
              (this._ad_complete = "media-ad-complete"),
              (this._media_start = "media-start"),
              (this._media_complete = "media-complete"),
              (this._error = "error"),
              (this._player_event_play = "play"),
              (this._player_event_pause = "pause"),
              (this._player_event_buffer = "buffer"),
              (this._player_event_stall = "stall"),
              (this._player_event_start = "start");
          }
          var I = 1.5;
          return {
            init: H,
            resolveDataForEvent: b,
            getContextData: c,
            resetSessionIds: f
          };
        })(),
        q = (function() {
          function a(a) {
            return void 0 === a.id
              ? (g.warning(
                  "Media - MediaInfo does not have value for media-id"
                ),
                !1)
              : void 0 !== a.length ||
                  (g.warning(
                    "Media - MediaInfo does not have value for playhead"
                  ),
                  !1);
          }
          function b(a) {
            return (
              void 0 !== a.position ||
              (g.warning(
                "Media - AdBreak Info does not have value for position"
              ),
              !1)
            );
          }
          function c(a) {
            return (
              void 0 !== a.id ||
              (g.warning("Media - Ad Info does not have value for ad id"), !1)
            );
          }
          function d(a) {
            return void 0 === a.position
              ? (g.warning(
                  "Media - Chapter Info does not have value for chapter position"
                ),
                !1)
              : void 0 === a.name
                ? (g.warning(
                    "Media - Chapter Info does not have value for chapter name"
                  ),
                  !1)
                : void 0 === a.offset
                  ? (g.warning(
                      "Media - Chapter Info does not have value for chapter offset"
                    ),
                    !1)
                  : void 0 !== a.length ||
                    (g.warning(
                      "Media - Chapter Info does not have value for chapter length"
                    ),
                    !1);
          }
          function f(a) {
            return void 0 === a.droppedFrames
              ? (g.warning(
                  "Media - QoS Info does not have value for dropped frames"
                ),
                !1)
              : void 0 === a.startupTime
                ? (g.warning(
                    "Media - QoS Info does not have value for startup time"
                  ),
                  !1)
                : void 0 === a.fps
                  ? (g.warning(
                      "Media - QoS Info does not have value for frames per second"
                    ),
                    !1)
                  : void 0 !== a.bitrate ||
                    (g.warning(
                      "Media - QoS Info does not have value for bitrate"
                    ),
                    !1);
          }
          function h(a) {
            return e.mSDK()
              ? e.mChannel()
                ? e.mOVP()
                  ? !!e.mPlayerName() ||
                    (g.warning(
                      "Media - Config object does not have value for playername."
                    ),
                    !1)
                  : (g.warning(
                      "Media - Config object does not have value for ovp."
                    ),
                    !1)
                : (g.warning(
                    "Media - Media - Config object does not have value for channel."
                  ),
                  !1)
              : (g.warning(
                  "Media - Config object does not have value for sdk."
                ),
                !1);
          }
          return {
            isValidMediaInfoObject: a,
            isValidAdBreakInfoObject: b,
            isValidAdInfoObject: c,
            isValidChapterInfoObject: d,
            isValidQoSInfoObject: f,
            isValidConfigObject: h
          };
        })(),
        r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (-1 != b.indexOf(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherContains = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          var c = a.length - b.length,
            d = a.lastIndexOf(b, c);
          return -1 !== d && d === c;
        }
        function c(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (c.prototype.matches = function(a) {
          var c = a[this.key];
          if (void 0 === c || null === c) return !1;
          if (this.values)
            for (var d = 0; d < this.values.length; ++d)
              if (b(c, this.values[d])) return !0;
          return !1;
        }),
          (a.MatcherEndsWith = c);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (String(b) === String(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherEquals = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          return void 0 !== a[this.key];
        }),
          (a.MatcherExists = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (Number(b) > Number(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherGreaterThan = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (Number(b) >= Number(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherGreaterThanOrEqual = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (Number(b) < Number(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherLessThan = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (Number(b) <= Number(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherLessThanOrEqual = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(b, c) {
          return (this.containsHandler = new a.MatcherContains(b, c)), this;
        }
        (b.prototype.matches = function(a) {
          return !this.containsHandler.matches(a);
        }),
          (a.MatcherNotContains = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(b, c) {
          return (this.equalsHandler = new a.MatcherEquals(b, c)), this;
        }
        (b.prototype.matches = function(a) {
          return !this.equalsHandler.matches(a);
        }),
          (a.MatcherNotEquals = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(b, c) {
          return (this._handler = new a.MatcherExists(b, c)), this;
        }
        (b.prototype.matches = function(a) {
          return !this._handler.matches(a);
        }),
          (a.MatcherNotExists = b);
      })(r);
      var r = r || {};
      !(function(a) {
        "use strict";
        function b(a, b) {
          return (this.key = a), (this.values = b), this;
        }
        (b.prototype.matches = function(a) {
          var b = a[this.key];
          if (void 0 === b || null === b) return !1;
          if (this.values)
            for (var c = 0; c < this.values.length; ++c)
              if (0 === b.indexOf(this.values[c])) return !0;
          return !1;
        }),
          (a.MatcherStartsWith = b);
      })(r);
      var s = (function() {
          function a(a) {
            return (
              (this.JSON_CONFIG_TEMPLATE = "template"),
              (this.JSON_CONFIG_MESSAGE_ID = "messageId"),
              (this.JSON_CONFIG_SHOW_RULE = "showRule"),
              (this.JSON_CONFIG_START_DATE = "startDate"),
              (this.MESSAGE_JSON_PAYLOAD = "payload"),
              (this.JSON_CONFIG_END_DATE = "endDate"),
              (this.JSON_CONFIG_SHOW_OFFLINE = "showOffline"),
              (this.JSON_CONFIG_AUDIENCES = "audiences"),
              (this.JSON_CONFIG_TRIGGERS = "triggers"),
              (this.JSON_CONFIG_ASSETS = "assets"),
              (this.MESSAGE_IMAGE_CACHE_DIR = "messageImages"),
              (this.JSON_DEFAULT_START_DATE = 0),
              (this.JSON_DEFAULT_SHOW_OFFLINE = "false"),
              (this.MESSAGE_ENUM_STRING_UNKNOWN = "unknown"),
              (this.MESSAGE_SHOW_RULE_STRING_ALWAYS = "always"),
              (this.MESSAGE_SHOW_RULE_STRING_ONCE = "once"),
              (this.MESSAGE_SHOW_RULE_STRING_UNTIL_CLICK = "untilClick"),
              (this.MESSAGE_TEMPLATE_STRING_ALERT = "alert"),
              (this.MESSAGE_TEMPLATE_STRING_FULLSCREEN = "fullscreen"),
              (this.MESSAGE_TEMPLATE_STRING_LOCAL_NOTIFICATION = "local"),
              (this.MESSAGE_TEMPLATE_STRING_CALLBACK = "callback"),
              (this.MESSAGE_TYPE_HANDLER = "handler"),
              (this.MESSAGE_TYPE = "type"),
              (this.COMBINED_VARS = "combinedVars"),
              (this.ADB_TEMPLATE_CALLBACK_URL = "templateurl"),
              (this.ADB_TEMPLATE_CALLBACK_BODY = "templatebody"),
              (this.ADB_TEMPLATE_CALLBACK_TYPE = "contenttype"),
              (this.ADB_TEMPLATE_CALLBACK_TIMEOUT = "timeout"),
              (this.ADB_TEMPLATE_TOKEN_START = "{"),
              (this.ADB_TEMPLATE_TOKEN_END = "}"),
              (this.ADB_TEMPLATE_TIMEOUT_DEFAULT = 2),
              (this.message = {}),
              (this.message[this.JSON_CONFIG_MESSAGE_ID] = ""),
              (this.message[this.JSON_CONFIG_TEMPLATE] = ""),
              (this.message[this.MESSAGE_TYPE_HANDLER] = null),
              (this.message[
                this.JSON_CONFIG_START_DATE
              ] = this.JSON_DEFAULT_START_DATE),
              (this.message[this.JSON_CONFIG_END_DATE] = null),
              (this.message[
                this.JSON_DEFAULT_SHOW_OFFLINE
              ] = this.JSON_DEFAULT_SHOW_OFFLINE),
              (this.message[this.JSON_CONFIG_AUDIENCES] = []),
              (this.message[this.JSON_CONFIG_TRIGGERS] = []),
              (this.message[this.MESSAGE_TYPE] = null),
              (this.message[this.COMBINED_VARS] = {}),
              (this.validLetters = {}),
              (this.validLetters.a = 1),
              (this.validLetters.b = 1),
              (this.validLetters.c = 1),
              (this.validLetters.d = 1),
              (this.validLetters.e = 1),
              (this.validLetters.f = 1),
              (this.validLetters.g = 1),
              (this.validLetters.h = 1),
              (this.validLetters.i = 1),
              (this.validLetters.j = 1),
              (this.validLetters.k = 1),
              (this.validLetters.l = 1),
              (this.validLetters.m = 1),
              (this.validLetters.n = 1),
              (this.validLetters.o = 1),
              (this.validLetters.p = 1),
              (this.validLetters.q = 1),
              (this.validLetters.r = 1),
              (this.validLetters.s = 1),
              (this.validLetters.t = 1),
              (this.validLetters.u = 1),
              (this.validLetters.v = 1),
              (this.validLetters.w = 1),
              (this.validLetters.x = 1),
              (this.validLetters.y = 1),
              (this.validLetters.z = 1),
              (this.validLetters[0] = 1),
              (this.validLetters[1] = 1),
              (this.validLetters[2] = 1),
              (this.validLetters[3] = 1),
              (this.validLetters[4] = 1),
              (this.validLetters[5] = 1),
              (this.validLetters[6] = 1),
              (this.validLetters[7] = 1),
              (this.validLetters[8] = 1),
              (this.validLetters[9] = 1),
              (this.validLetters._ = 1),
              (this.validLetters["."] = 1),
              (this.validLetters["%"] = 1),
              b.call(this, a)
                ? this
                : (g.warning("Message - Initialization failed"), null)
            );
          }
          function b(a) {
            if ("object" == typeof a)
              return a[this.JSON_CONFIG_TEMPLATE]
                ? ((this.message[this.JSON_CONFIG_TEMPLATE] =
                    a[this.JSON_CONFIG_TEMPLATE]),
                  this.message[this.JSON_CONFIG_TEMPLATE] !=
                  this.MESSAGE_TEMPLATE_STRING_CALLBACK
                    ? (g.warning(
                        "Message - unable to create instance of message with that template"
                      ),
                      !1)
                    : ((this.message[
                        this.MESSAGE_TYPE
                      ] = this.MESSAGE_TEMPLATE_STRING_CALLBACK),
                      c.call(this, a)))
                : (g.warning(
                    "Message - template is required for postback message"
                  ),
                  !1);
          }
          function c(a) {
            if (a) {
              if (
                !a[this.JSON_CONFIG_MESSAGE_ID] ||
                "" === a[this.JSON_CONFIG_MESSAGE_ID]
              )
                return (
                  g.warning(
                    "Message - unable to create instance of message without message id"
                  ),
                  !1
                );
              if (
                ((this.message[this.JSON_CONFIG_MESSAGE_ID] =
                  a[this.JSON_CONFIG_MESSAGE_ID]),
                !a[this.MESSAGE_JSON_PAYLOAD])
              )
                return (
                  g.warning(
                    "Data Callback - Unable to create data callback. payload is empty"
                  ),
                  !1
                );
              this.message[this.MESSAGE_JSON_PAYLOAD] =
                a[this.MESSAGE_JSON_PAYLOAD];
              if (!d.call(this)) return !1;
              if (
                a[this.JSON_CONFIG_SHOW_RULE] &&
                "" !== a[this.JSON_CONFIG_SHOW_RULE]
              ) {
                if (
                  a[this.JSON_CONFIG_SHOW_RULE] ==
                  this.message[this.MESSAGE_ENUM_STRING_UNKNOWN]
                )
                  return (
                    g.warning(
                      "Message - Messages - Unable to create message. showrule is invalid"
                    ),
                    !1
                  );
                if (!f.call(this, a[this.JSON_CONFIG_SHOW_RULE]))
                  return g.warning("Message - unsupported message rule"), !1;
                this.message[this.JSON_CONFIG_SHOW_RULE] =
                  a[this.JSON_CONFIG_SHOW_RULE];
              }
              var b;
              if (
                ((b =
                  a[this.JSON_CONFIG_START_DATE] &&
                  "" !== a[this.JSON_CONFIG_START_DATE]
                    ? a[this.JSON_CONFIG_START_DATE]
                    : this.JSON_DEFAULT_START_DATE),
                (this.message[this.JSON_CONFIG_START_DATE] = b),
                !a[this.JSON_CONFIG_END_DATE] ||
                  "" === a[this.JSON_CONFIG_END_DATE])
              )
                return (
                  g.warning(
                    "Message - cannot create message. endDate is invalid."
                  ),
                  !1
                );
              (this.message[this.JSON_CONFIG_END_DATE] =
                a[this.JSON_CONFIG_END_DATE]),
                a[this.JSON_CONFIG_SHOW_OFFLINE] &&
                "" !== a[this.JSON_CONFIG_SHOW_OFFLINE]
                  ? (this.message[this.JSON_CONFIG_SHOW_OFFLINE] =
                      a[this.JSON_CONFIG_SHOW_OFFLINE])
                  : (this.message[this.JSON_CONFIG_SHOW_OFFLINE] = this.message[
                      this.JSON_DEFAULT_SHOW_OFFLINE
                    ]);
              var c, e;
              if (a[this.JSON_CONFIG_AUDIENCES]) {
                var h = a[this.JSON_CONFIG_AUDIENCES];
                for (e = 0; e < h.length; ++e) {
                  var i = h[e];
                  (c = new t.Matcher(i)),
                    this.message[this.JSON_CONFIG_AUDIENCES].push(c);
                }
              }
              if (a[this.JSON_CONFIG_TRIGGERS]) {
                var j = a[this.JSON_CONFIG_TRIGGERS];
                for (e = 0; e < j.length; ++e) {
                  var k = j[e];
                  (c = new t.Matcher(k)),
                    this.message[this.JSON_CONFIG_TRIGGERS].push(c);
                }
                return this.message[this.JSON_CONFIG_TRIGGERS].length <= 0
                  ? (g.warning(
                      "Messages - Unable to load message - at least one valid trigger is required for a message."
                    ),
                    !1)
                  : (g.debug(
                      "Messages - " +
                        this.message[this.JSON_CONFIG_TRIGGERS].length +
                        " triggers found"
                    ),
                    !0);
              }
              return g.warning("Messages - empty messages"), !1;
            }
          }
          function d() {
            var a = this.message[this.MESSAGE_JSON_PAYLOAD];
            return a[this.ADB_TEMPLATE_CALLBACK_URL] &&
              "" !== a[this.ADB_TEMPLATE_CALLBACK_URL]
              ? ((this.message[this.ADB_TEMPLATE_CALLBACK_URL] =
                  a[this.ADB_TEMPLATE_CALLBACK_URL]),
                a[this.ADB_TEMPLATE_CALLBACK_TIMEOUT]
                  ? (this.message[this.ADB_TEMPLATE_CALLBACK_TIMEOUT] =
                      a[this.ADB_TEMPLATE_CALLBACK_TIMEOUT])
                  : (g.warning("Data Callback - setting default timeout"),
                    (this.message[
                      this.ADB_TEMPLATE_CALLBACK_TIMEOUT
                    ] = this.message[this.ADB_TEMPLATE_TIMEOUT_DEFAULT])),
                a[this.ADB_TEMPLATE_CALLBACK_BODY] &&
                "" !== a[this.ADB_TEMPLATE_CALLBACK_BODY]
                  ? ((this.message[this.ADB_TEMPLATE_CALLBACK_BODY] =
                      a[this.ADB_TEMPLATE_CALLBACK_BODY]),
                    (this.message[this.ADB_TEMPLATE_CALLBACK_TYPE] =
                      a[this.ADB_TEMPLATE_CALLBACK_TYPE]))
                  : g.warning(
                      "Data Callback - Unable to read templatebody. This is not a required field"
                    ),
                !0)
              : (g.warning(
                  "Data Callback - Unable to create data callback. templateurl is required"
                ),
                !1);
          }
          function f(a) {
            return (
              a === this.MESSAGE_SHOW_RULE_STRING_ALWAYS ||
              a === this.MESSAGE_SHOW_RULE_STRING_ONCE
            );
          }
          function i(a) {
            return a;
          }
          function l(a) {
            var b = {};
            k.getMarketingCloudIDAsync(function(a) {
              b["%mcid%"] = a;
            }),
              (b["%timestampz%"] = ADBMobile_platform.getDateInISOString()),
              (b["%timestampu%"] = ADBMobile_platform.getTimeSince1970()),
              (b["%sdkver%"] = j.codeVersion),
              (b["%cachebust%"] = "" + 1e8 * Math.random());
            var c = h.serializeParameters(a);
            if (
              (c.length > 2 && (c = c.substring(1)), (b["%all_url%"] = c), a)
            ) {
              var d = JSON.stringify(a);
              d && (b["%all_json%"] = d);
            }
            return b;
          }
          function m(a) {
            var b = [];
            if (a && "" !== a) {
              var c,
                d = a.length;
              for (c = 0; c < d; c++) {
                if (a.substring(c, c + 1) === this.ADB_TEMPLATE_TOKEN_START) {
                  var e;
                  for (e = c + 1; e < d; e++) {
                    if (a.substring(e, e + 1) === this.ADB_TEMPLATE_TOKEN_END)
                      break;
                  }
                  if (e == d) break;
                  var f = a.substring(c, e + 1);
                  !0 === q.call(this, f.substring(1, f.length - 1)) &&
                    (b.push(f), (c = e));
                }
              }
            } else
              g.warning("findTokensForExpansion: empty string with tokens");
            return b;
          }
          function n(a, b) {
            var c = {},
              d = this.message[this.COMBINED_VARS] || {};
            if (a)
              for (var e = 0; e < a.length; ++e) {
                var f = a[e],
                  g = f.substring(1, f.length - 1).toLowerCase(),
                  h = d[g];
                c[f] = h ? (b ? encodeURIComponent(h) : h) : "";
              }
            return c;
          }
          function o(a, b) {
            var c,
              d = a;
            for (c in b)
              if (b.hasOwnProperty(c))
                for (; -1 != d.indexOf(c); ) {
                  var e = d.indexOf(c),
                    f = b[c],
                    g = d.slice(0, e),
                    h = d.slice(e + c.length);
                  d = "" !== f ? g + f + h : g + h;
                }
            return d;
          }
          function p(a, b) {
            e.getPrivacyStatus() === e.PRIVACY_STATUS_OPT_IN &&
              (g.debug(
                "Messaging - Sending signal request (" + a.toString() + ")"
              ),
              ADBMobile_platform.httpRequestAsync(
                a,
                "POST",
                { "Content-type": "application/x-www-form-urlencoded" },
                b,
                2e3,
                function(a, b, c) {
                  200 == a
                    ? g.debug("Messaging - Successfully sent hit (" + c + ")")
                    : g.error(
                        "Messaging - Unable to send hit (" +
                          c +
                          ") response (" +
                          b +
                          ")"
                      );
                }
              ));
          }
          function q(a) {
            var b,
              c = !0;
            for (b = 0; b < a.length; b++) {
              var d = a.charAt(b).toLowerCase();
              if (!this.validLetters[d]) {
                c = !1;
                break;
              }
            }
            return c;
          }
          return (
            (a.prototype.shouldShowForVariables = function(a, b) {
              var c = {};
              if (
                (b && h.append(c, b),
                a && h.append(c, a),
                h.append(c, l.call(this, c)),
                (this.message[this.COMBINED_VARS] = c),
                this.message[this.JSON_CONFIG_START_DATE] &&
                  ADBMobile_platform.getTimeSince1970() <
                    this.message[this.JSON_CONFIG_START_DATE])
              )
                return !1;
              if (
                this.message[this.JSON_CONFIG_END_DATE] &&
                ADBMobile_platform.getTimeSince1970() >
                  this.message[this.JSON_CONFIG_END_DATE]
              )
                return !1;
              var d = this.message[this.JSON_CONFIG_TRIGGERS];
              if (d)
                for (var e = i.call(this, b), f = 0; f < d.length; ++f) {
                  var g = d[f];
                  if (!g.matchesInMaps(a, e)) return !1;
                }
              return !0;
            }),
            (a.prototype.show = function() {
              var a = this.message[this.ADB_TEMPLATE_CALLBACK_URL],
                b = a,
                c = m.call(this, a),
                d = n.call(this, c, !0),
                e = ["{%all_url%}"],
                f = n.call(this, e, !1);
              h.append(d, f), d && (b = o.call(this, a, d));
              var g = this.message[this.ADB_TEMPLATE_CALLBACK_BODY],
                i = g;
              if (g) {
                var j = ADBMobile_platform.decodeBase64String(g),
                  k = m.call(this, j),
                  l = this.message[this.ADB_TEMPLATE_CALLBACK_TYPE],
                  q = !0;
                l &&
                  -1 != l.toLowerCase().search("application/json") &&
                  (q = !1);
                var r = n.call(this, k, q),
                  s = [];
                s.push("{%all_url%}"), s.push("{%all_json%}");
                var t = n.call(this, s, !1);
                h.append(r, t), r && (i = o.call(this, j, r));
              }
              p.call(this, b, i);
            }),
            { Message: a }
          );
        })(),
        t = (function() {
          "use strict";
          function a(a, b, c) {
            if (!r || !a || !b) return null;
            var d = null;
            switch (a) {
              case "eq":
                d = r.MatcherEquals;
                break;
              case "ne":
                d = r.MatcherNotEquals;
                break;
              case "gt":
                d = r.MatcherGreaterThan;
                break;
              case "lt":
                d = r.MatcherLessThan;
                break;
              case "ge":
                d = r.MatcherGreaterThanOrEqual;
                break;
              case "le":
                d = r.MatcherLessThanOrEqual;
                break;
              case "co":
                d = r.MatcherContains;
                break;
              case "nc":
                d = r.MatcherNotContains;
                break;
              case "sw":
                d = r.MatcherStartsWith;
                break;
              case "ew":
                d = r.MatcherEndsWith;
                break;
              case "ex":
                d = r.MatcherExists;
                break;
              case "nx":
                d = r.MatcherNotExists;
            }
            var e = b.toLowerCase();
            return d ? new d(e, c) : null;
          }
          function b(b) {
            return (
              b &&
                ((this._json = b),
                (this._handler = a(b.matches, b.key, b.values))),
              this
            );
          }
          return (
            (b.prototype.matchesInMaps = function(a, b) {
              if (this._handler) {
                var c = {};
                return h.append(c, a), h.append(c, b), this._handler.matches(c);
              }
              return !1;
            }),
            { Matcher: b }
          );
        })(),
        u = (function() {
          function a() {
            (k = []), (l = !1), (m = []);
          }
          function b(a) {
            if (a) {
              for (var b = [], c = 0; c < a.length; ++c)
                "callback" === a[c].template && b.push(new s.Message(a[c]));
              k = b;
            }
          }
          function c() {
            for (var a = 0; a < m.length; ++a) i(m[a].vars, m[a].cData);
            (m = []), (l = !0);
          }
          function d() {
            b(e.getMessages());
            var a = e.getRemotes();
            a && a.messages
              ? ADBMobile_platform.httpRequestAsync(
                  a.messages,
                  "GET",
                  {},
                  null,
                  500,
                  function(a, d) {
                    if (200 == a && d)
                      try {
                        (responseJSON = JSON.parse(d)),
                          b(responseJSON.messages);
                      } catch (e) {
                        g.debug(
                          "remotes.messages - Unable to parse response (" +
                            e +
                            ")"
                        );
                      }
                    c();
                  }
                )
              : c();
          }
          function f(a) {
            var b = {};
            for (var c in a)
              if (a.hasOwnProperty(c)) {
                var d = c.toLowerCase();
                b[d] = a[c];
              }
            return b;
          }
          function i(a, b) {
            if (k && k.length > 0)
              for (var c = f(a), d = f(b), e = 0; e < k.length; ++e) {
                var g = k[e];
                g && g.shouldShowForVariables(c, d) && g.show();
              }
          }
          function j(a, b) {
            if (a && b)
              return l
                ? void i(a, b)
                : void m.push({ vars: h.clone(a), cData: h.clone(b) });
          }
          var k = [],
            l = !1,
            m = [];
          return { init: d, checkFor3rdPartyCallbacks: j, reset: a };
        })();
      !(function(a) {
        "use strict";
        function b(a, b) {
          var c = (65535 & a) + (65535 & b);
          return (((a >> 16) + (b >> 16) + (c >> 16)) << 16) | (65535 & c);
        }
        function c(a, b) {
          return (a << b) | (a >>> (32 - b));
        }
        function d(a, d, e, f, g, h) {
          return b(c(b(b(d, a), b(f, h)), g), e);
        }
        function e(a, b, c, e, f, g, h) {
          return d((b & c) | (~b & e), a, b, f, g, h);
        }
        function f(a, b, c, e, f, g, h) {
          return d((b & e) | (c & ~e), a, b, f, g, h);
        }
        function g(a, b, c, e, f, g, h) {
          return d(b ^ c ^ e, a, b, f, g, h);
        }
        function h(a, b, c, e, f, g, h) {
          return d(c ^ (b | ~e), a, b, f, g, h);
        }
        function i(a, c) {
          (a[c >> 5] |= 128 << (c % 32)), (a[14 + (((c + 64) >>> 9) << 4)] = c);
          var d,
            i,
            j,
            k,
            l,
            m = 1732584193,
            n = -271733879,
            o = -1732584194,
            p = 271733878;
          for (d = 0; d < a.length; d += 16)
            (i = m),
              (j = n),
              (k = o),
              (l = p),
              (m = e(m, n, o, p, a[d], 7, -680876936)),
              (p = e(p, m, n, o, a[d + 1], 12, -389564586)),
              (o = e(o, p, m, n, a[d + 2], 17, 606105819)),
              (n = e(n, o, p, m, a[d + 3], 22, -1044525330)),
              (m = e(m, n, o, p, a[d + 4], 7, -176418897)),
              (p = e(p, m, n, o, a[d + 5], 12, 1200080426)),
              (o = e(o, p, m, n, a[d + 6], 17, -1473231341)),
              (n = e(n, o, p, m, a[d + 7], 22, -45705983)),
              (m = e(m, n, o, p, a[d + 8], 7, 1770035416)),
              (p = e(p, m, n, o, a[d + 9], 12, -1958414417)),
              (o = e(o, p, m, n, a[d + 10], 17, -42063)),
              (n = e(n, o, p, m, a[d + 11], 22, -1990404162)),
              (m = e(m, n, o, p, a[d + 12], 7, 1804603682)),
              (p = e(p, m, n, o, a[d + 13], 12, -40341101)),
              (o = e(o, p, m, n, a[d + 14], 17, -1502002290)),
              (n = e(n, o, p, m, a[d + 15], 22, 1236535329)),
              (m = f(m, n, o, p, a[d + 1], 5, -165796510)),
              (p = f(p, m, n, o, a[d + 6], 9, -1069501632)),
              (o = f(o, p, m, n, a[d + 11], 14, 643717713)),
              (n = f(n, o, p, m, a[d], 20, -373897302)),
              (m = f(m, n, o, p, a[d + 5], 5, -701558691)),
              (p = f(p, m, n, o, a[d + 10], 9, 38016083)),
              (o = f(o, p, m, n, a[d + 15], 14, -660478335)),
              (n = f(n, o, p, m, a[d + 4], 20, -405537848)),
              (m = f(m, n, o, p, a[d + 9], 5, 568446438)),
              (p = f(p, m, n, o, a[d + 14], 9, -1019803690)),
              (o = f(o, p, m, n, a[d + 3], 14, -187363961)),
              (n = f(n, o, p, m, a[d + 8], 20, 1163531501)),
              (m = f(m, n, o, p, a[d + 13], 5, -1444681467)),
              (p = f(p, m, n, o, a[d + 2], 9, -51403784)),
              (o = f(o, p, m, n, a[d + 7], 14, 1735328473)),
              (n = f(n, o, p, m, a[d + 12], 20, -1926607734)),
              (m = g(m, n, o, p, a[d + 5], 4, -378558)),
              (p = g(p, m, n, o, a[d + 8], 11, -2022574463)),
              (o = g(o, p, m, n, a[d + 11], 16, 1839030562)),
              (n = g(n, o, p, m, a[d + 14], 23, -35309556)),
              (m = g(m, n, o, p, a[d + 1], 4, -1530992060)),
              (p = g(p, m, n, o, a[d + 4], 11, 1272893353)),
              (o = g(o, p, m, n, a[d + 7], 16, -155497632)),
              (n = g(n, o, p, m, a[d + 10], 23, -1094730640)),
              (m = g(m, n, o, p, a[d + 13], 4, 681279174)),
              (p = g(p, m, n, o, a[d], 11, -358537222)),
              (o = g(o, p, m, n, a[d + 3], 16, -722521979)),
              (n = g(n, o, p, m, a[d + 6], 23, 76029189)),
              (m = g(m, n, o, p, a[d + 9], 4, -640364487)),
              (p = g(p, m, n, o, a[d + 12], 11, -421815835)),
              (o = g(o, p, m, n, a[d + 15], 16, 530742520)),
              (n = g(n, o, p, m, a[d + 2], 23, -995338651)),
              (m = h(m, n, o, p, a[d], 6, -198630844)),
              (p = h(p, m, n, o, a[d + 7], 10, 1126891415)),
              (o = h(o, p, m, n, a[d + 14], 15, -1416354905)),
              (n = h(n, o, p, m, a[d + 5], 21, -57434055)),
              (m = h(m, n, o, p, a[d + 12], 6, 1700485571)),
              (p = h(p, m, n, o, a[d + 3], 10, -1894986606)),
              (o = h(o, p, m, n, a[d + 10], 15, -1051523)),
              (n = h(n, o, p, m, a[d + 1], 21, -2054922799)),
              (m = h(m, n, o, p, a[d + 8], 6, 1873313359)),
              (p = h(p, m, n, o, a[d + 15], 10, -30611744)),
              (o = h(o, p, m, n, a[d + 6], 15, -1560198380)),
              (n = h(n, o, p, m, a[d + 13], 21, 1309151649)),
              (m = h(m, n, o, p, a[d + 4], 6, -145523070)),
              (p = h(p, m, n, o, a[d + 11], 10, -1120210379)),
              (o = h(o, p, m, n, a[d + 2], 15, 718787259)),
              (n = h(n, o, p, m, a[d + 9], 21, -343485551)),
              (m = b(m, i)),
              (n = b(n, j)),
              (o = b(o, k)),
              (p = b(p, l));
          return [m, n, o, p];
        }
        function j(a) {
          var b,
            c = "";
          for (b = 0; b < 32 * a.length; b += 8)
            c += String.fromCharCode((a[b >> 5] >>> (b % 32)) & 255);
          return c;
        }
        function k(a) {
          var b,
            c = [];
          for (c[(a.length >> 2) - 1] = void 0, b = 0; b < c.length; b += 1)
            c[b] = 0;
          for (b = 0; b < 8 * a.length; b += 8)
            c[b >> 5] |= (255 & a.charCodeAt(b / 8)) << (b % 32);
          return c;
        }
        function l(a) {
          return j(i(k(a), 8 * a.length));
        }
        function m(a, b) {
          var c,
            d,
            e = k(a),
            f = [],
            g = [];
          for (
            f[15] = g[15] = void 0,
              e.length > 16 && (e = i(e, 8 * a.length)),
              c = 0;
            c < 16;
            c += 1
          )
            (f[c] = 909522486 ^ e[c]), (g[c] = 1549556828 ^ e[c]);
          return (
            (d = i(f.concat(k(b)), 512 + 8 * b.length)), j(i(g.concat(d), 640))
          );
        }
        function n(a) {
          var b,
            c,
            d = "0123456789abcdef",
            e = "";
          for (c = 0; c < a.length; c += 1)
            (b = a.charCodeAt(c)),
              (e += d.charAt((b >>> 4) & 15) + d.charAt(15 & b));
          return e;
        }
        function o(a) {
          return unescape(encodeURIComponent(a));
        }
        function p(a) {
          return l(o(a));
        }
        function q(a) {
          return n(p(a));
        }
        function r(a, b) {
          return m(o(a), o(b));
        }
        function s(a, b) {
          return n(r(a, b));
        }
        function t(a, b, c) {
          return b ? (c ? r(b, a) : s(b, a)) : c ? p(a) : q(a);
        }
        a.md5 = t;
      })(i);
      var v = {
        version: j,
        analytics: {
          trackState: b.trackState,
          trackAction: b.trackAction,
          getTrackingIdentifier: a.getAIDAsync
        },
        config: {
          setUserIdentifier: e.setUserIdentifier,
          getUserIdentifier: e.getUserIdentifier,
          getAllIdentifiersAsync: e.getAllIdentifiersAsync,
          setPrivacyStatus: e.setPrivacyStatus,
          getPrivacyStatus: e.getPrivacyStatus,
          setLoggerCallback: g.setLoggerCallback,
          setDebugLogging: g.setDebugLogging,
          getDebugLogging: g.getDebugLogging,
          PRIVACY_STATUS_OPT_IN: e.PRIVACY_STATUS_OPT_IN,
          PRIVACY_STATUS_OPT_OUT: e.PRIVACY_STATUS_OPT_OUT
        },
        visitor: {
          syncIdentifiers: k.idSync,
          getMarketingCloudID: k.getMarketingCloudIDAsync
        },
        audienceManager: {
          submitSignal: d.submitSignal,
          getVisitorProfile: d.getVisitorProfile,
          getDpid: d.getDpid,
          getDpuuid: d.getDpuuid,
          setDpidAndDpuuid: d.setDpidAndDpuuid
        },
        media: {
          setDelegate: n.setDelegate,
          trackSessionStart: n.trackSessionStart,
          trackPlay: n.trackPlay,
          trackPause: n.trackPause,
          trackError: n.trackError,
          trackEvent: n.trackEvent,
          trackComplete: n.trackComplete,
          trackSessionEnd: n.trackSessionEnd,
          StreamType: n.StreamType,
          Event: n.Event,
          MediaObjectKey: n.MediaObjectKey,
          VideoMetadataKeys: n.VideoMetadataKeys,
          AdMetadataKeys: n.AdMetadataKeys,
          createMediaObject: n.createMediaObject,
          createAdBreakObject: n.createAdBreakObject,
          createChapterObject: n.createChapterObject,
          createAdObject: n.createAdObject,
          createQoSObject: n.createQoSObject,
          trackLoad: n.trackLoad,
          trackStart: n.trackStart,
          trackUnload: n.trackUnload,
          MediaInfo: n.MediaInfo,
          AdInfo: n.AdInfo,
          ChapterInfo: n.ChapterInfo,
          AdBreakInfo: n.AdBreakInfo,
          QoSInfo: n.QoSInfo,
          BUFFER_START: n.Event.BufferStart,
          BUFFER_COMPLETE: n.Event.BufferComplete,
          SEEK_START: n.Event.SeekStart,
          SEEK_COMPLETE: n.Event.SeekComplete,
          BITRATE_CHANGE: n.Event.BitrateChange,
          CHAPTER_START: n.Event.ChapterStart,
          CHAPTER_COMPLETE: n.Event.ChapterComplete,
          CHAPTER_SKIP: n.Event.ChapterSkip,
          AD_BREAK_START: n.Event.AdBreakStart,
          AD_BREAK_COMPLETE: n.Event.AdBreakComplete,
          AD_BREAK_SKIP: n.Event.AdBreakSkip,
          AD_START: n.Event.AdStart,
          AD_COMPLETE: n.Event.AdComplete,
          AD_SKIP: n.Event.AdSkip,
          STREAM_TYPE_LIVE: n.StreamType.LIVE,
          STREAM_TYPE_VOD: n.StreamType.VOD
        }
      };
      return e.init(), a.init(), k.init(), u.init(), n.init(), v;
    })();
  return ADBMobile;
}

module.exports = ADBinit;


// WEBPACK FOOTER //
// ./src/vendor/adbmobile-chromecast.js